<template>
    <el-container class="scoring" :style="scoringStyle">
        <el-header>
            <el-row>
                <el-col :span="2" style="text-align: left; ">
                  <div class="nav-buttons">
                    <div class="nav-item">
                      <i class="el-icon-s-marketing icon" @click="openProgress"></i>
                      <span>进度</span>
                    </div>

                    <div class="nav-item">
                      <i class="el-icon-search icon"  @click="openSearchDialog"></i>
                      <span>搜索</span>
                    </div>

                    <div class="nav-item">
                      <i class="el-icon-s-order icon"  @click="jumpCheck"></i>
                      <span>检查</span>
                    </div>
                  </div>
                </el-col>
                <el-col :span="6" style="text-align: left;">
<!--                    <el-tooltip class="item" effect="dark" :content="examInfo.name" placement="bottom">-->
                        <div>
                            <span class="head" v-if="examInfo.name!=null" >{{showExamName(examInfo.name)+"("+examInfo.id+")"}}，</span>
                            <span class="head">人数：{{examInfo.joinCount||0}}, 未阅：{{totalCount}}, 已阅：{{yyCount}}</span>
                        </div>
<!--                    </el-tooltip>-->
                </el-col>
                <el-col :span="2">
                  <el-select v-model="yyOrderBy" placeholder="请选择" @change="reload">
                    <el-option v-for="item in yyOrderOptions" :key="item.key" :label="item.name" :value="item.key"></el-option>
                  </el-select>
                </el-col>
                <el-col :span="2" style="padding: 0px 12px;">
                  <el-checkbox v-model="showAllChecked" v-if="userInfo.id==examInfo.createrId" @change="showAllChange">全部记录</el-checkbox>
                </el-col>
                <!-- <el-col :span="4" style="padding: 0px 12px;">
                  缩放比例：
                  <el-button :class="{ 'active': true } " class="btn" @click="scaleChange(0.8)">80</el-button>
                  <el-button @click="scaleChange(1)" >100</el-button>
                  <el-button @click="scaleChange(2)">110</el-button>
                </el-col> -->
                <!-- <el-col :span="10" style="text-align: right; "> -->
                <el-col :span="8" style="text-align: left; ">
                    <span class="head">{{(selZgInfo!=null && selZgInfo.abPaper)?(selZgInfo.abPaper+"卷，"):""}}{{(baseSetting.showStudentInfo && selZgInfo!=null)?("学生:"+selZgInfo.studentNo):""}}</span>
                    <span class="head" v-if="baseSetting.showStudentInfo && selZgInfo!=null">, {{selZgInfo.studentName}}，</span>
                    <span class="head" v-if="baseSetting.showKg && selZgInfo!=null">客观分数：{{selZgInfo.kgScore}}</span>
<!--                    <i class="head el-icon-time icon"  @click="isDrawer=true"></i>-->
                </el-col>

            </el-row>

        </el-header>

        <el-container>
            <el-aside :width="asideWidth" style="overflow-x: hidden;">

                <el-menu :collapse="isCollapse" :default-active="activeIndex" :default-openeds="defaultActive" :style="{ height: menuHeight+'px'}">
                    <template v-for="(item,index) in menuData">
                        <!--表示 有一级菜单-->
                        <div v-if="!item.children || item.children.length == 0">
                            <el-menu-item class="dropItem" :index="item.key" @click="menuClick(item)">
                                <i v-if="item.icon" :class="item.icon"></i>
                                <span v-if="item.name" slot="title">{{ item.name}}</span>
                            </el-menu-item>

                        </div>

                        <!--表示 有二级或者多级菜单 -->
                        <el-submenu v-if="item.children && item.children.length >= 0" :index="item.key"  class="dropItem">
                            <template slot="title">
                                <i v-if="item.icon" :class="item.icon"></i>
                                <span v-if="item.name" slot="title">{{item.name}}</span>
                            </template>
                            <!--直接定位到子路由上，子路由也可以实现导航功能-->
                            <div v-for="(citem, cindex) in item.children">
                              <div style="width: 100%" v-if="!citem.key.includes('hc') || !citem.key.includes('tc')">

                                <el-menu-item v-if="!citem.children || citem.children.length == 0" :index="citem.key" @click="menuClick(citem)">

                                    <!-- <span slot="title" v-if="!citem.key.includes('hc')">{{citem.name}}</span> -->
                                    <span slot="title"> {{citem.name}}</span>
                                  
                                </el-menu-item>

                                <el-submenu v-if="citem.children && citem.children.length >= 0 " :index="citem.key"  class="dropItem">
                                  <template slot="title">
                                      <i v-if="citem.icon" :class="citem.icon"></i>
                                      <span v-if="citem.name" slot="title">{{citem.name}}</span>
                                  </template>
                                  <div v-for="(subItem, subIndex) in citem.children">
                                      <el-menu-item :index="subItem.key" @click="menuClick(subItem, subIndex, citem.children)">
                                          <span slot="title">
                                            {{subItem.name}}
                                          </span>
                                      </el-menu-item>

                                  </div>
                                </el-submenu>
                                </div>
                                <div v-else>
                                <el-menu-item v-if="!citem.studentCheckType" :index="citem.key" @click="menuClick(citem)">
                                  <span slot="title">
                                        <!-- 过滤 / 前的文字-->
                                        <span>{{ citem.name.replace(/\/(\d+)\)$/, '/') }}</span>

                                        <!-- 总数-->
                                        <el-button 
                                          type="text" 
                                          size="mini" 
                                          @click.stop="handleNumberClick(citem,item)"
                                          style="margin:0; padding:0 1px; color:#1890ff; vertical-align:middle;"
                                        >
                                          {{ citem.name.match(/\/(\d+)\)$/)[1] }}
                                        </el-button>

                                        <!-- 括号 -->
                                        <span>)</span>
                                      </span>
                                </el-menu-item>


                                <el-submenu v-if="citem.studentCheckType" :index="citem.key"  class="dropItem">
                                  <template slot="title">
                                      <i v-if="citem.icon" :class="citem.icon"></i>
                                      <span v-if="citem.name" slot="title">{{citem.name}}</span>
                                  </template>
                                  <div v-for="(subItem, subIndex) in citem.children">
                                      <el-menu-item :index="subItem.key" @click="menuClick(subItem, subIndex, citem.children)">
                                          <span slot="title">
                                            {{subItem.name}}
                                          </span>
                                      </el-menu-item>

                                  </div>
                                </el-submenu>
                                </div>

                            </div>

                        </el-submenu>
                    </template>
                </el-menu>


            </el-aside>
            <el-main :style="mainStyle" v-loading="loading">
                <div style="float: left; padding-top: 40px;" id="canvasDiv">
                    <!-- 画布 （画布点击事件） -->
                    <canvas id="myCanvas1"  :width="canvasWidth" :height="canvasHeight" @click.stop="canvasClick" >
                    </canvas>
                    <!-- {{ drawList }} -->
                    <!-- 批阅记录(分数，√× 等) -->
                    <scorePoint ref="scorePoint" :w="item.w" :h="item.h" :x="item.showX" :y="item.showY" :id="item.index" :arrIdx="index" v-for="(item, index) in drawList"
                           :type="item.type" :other="item" :tiScore="item.score" :eColor="item.color" :isDraggable="item.isD" :isResizable="item.isR" :caidianScore="caiDian?.myScore ?? 0 "  :zgInfo="selZgInfo"
                            @changeScore="changeScore" @select="selectPoint" @repos="changePoint" @quickScore="quickScoreSet" @deleteMe="spDeleteMe" @changeCaiDianScore="changeCaiDianScore" >
                    </scorePoint>

                </div>

                <!-- 右侧打分板 -->
                <rightPanel ref="rightPanel" :zgInfo="selZgInfo" :visible="selZgInfo!=null" :showAllExam="baseSetting.showAllExam" :isEdit="isEdit" :selMenu="selMenu" @quickScore="quickScoreAction"
                            @changeMode="rpChangeMode" @okExam="openViewer" @submitScore="rpSubmitScore" @submitNext="submitNext" @reEdit="reEdit" 

                            @submitScoreReCheck="rpSubmitScoreRecheck"></rightPanel>
                <!-- √× 批阅栏 -->
                <operPanel ref="operPanel" :status="selZgInfo.status" :x="operInfo.x" :y="operInfo.y" :visible="selZgInfo!=null" v-if="selZgInfo!=null" @ok="operOK" @updateOptionInfo="updateOptionInfo"></operPanel>

            </el-main>
        </el-container>

        <el-image-viewer v-if="showViewer && examImageList" :on-close="closeViewer" :url-list="examImageList" />
        <searchDialog ref="searchDialog" @ok="searchStudentOK"></searchDialog>

        <el-drawer title="已阅列表" :visible.sync="isDrawer" :modal="false" direction="rtl" :before-close="handleDrawerClose">
            <recentList ref="recentList" :examId="examId" :examSeq="zgForm.examSeq" :show="isDrawer" @ok="recentClick"></recentList>
        </el-drawer>

        <el-dialog title='学生列表' width="30%"  :visible.sync="dialogVisible" :close-on-click-modal="false">
          <el-table v-loading="loadingStudent" :data="tableData" align='center'>
            <el-table-column type="index" width="70" label="序号"></el-table-column>
            <el-table-column prop="my_no" label="学号"  align='left' ></el-table-column>
            <el-table-column prop="nick_name" label="姓名"  align='left' ></el-table-column>
          </el-table>
          <pagination  :pageSize="searchForm.pageSize" :currentPage="searchForm.pageNo" :pageTotal="searchForm.totalCount" @handleCurrentChange="handleCurrentChange" @handleSizeChange="handleSizeChange"></pagination>
          
          <div slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false">取 消</el-button>
          </div>
        
        </el-dialog>

        <progressDialog ref="progressDialog" :progress="selProgress" ></progressDialog>
    </el-container>

    
    
</template>

<script>
    import * as mUtils from '@/utils/mUtils'
    import {mapState, mapActions} from 'vuex'
    import * as simpleApi from "request/simple";
    import rightPanel from "./rightPanel";
    import operPanel from "./operPanel";
    import scorePoint from "./scorePoint";
    import searchDialog from "./searchDialog";
    import recentList from "./recentList";
    import ElImageViewer from 'element-ui/packages/image/src/image-viewer'
    import XEUtils from "xe-utils";
    import {splitTime, suoXiao} from "../../../utils/mUtils";
    import key from 'keymaster'
    import { first } from 'underscore';
    // src\views\exam\newExam\progressDialog.vue
    import progressDialog from "../newExam/progressDialog";

    export default {
        name: 'scanPre',
        data(){
            return {
                examId: null, loading: false, isDrawer: false, showAllChecked: false, scoringStyle: {}, asideWidth: "200px", mainStyle: {},
                formStyle: {}, 
                canvasWidth: 1000, 
                canvasHeight: 1000, 
                // baseWidth: 1000, 
                // baseHeight: 1000, 
                showViewer: false,
                menuHeight: 700,
                yyOrderBy: 'zg.uddt desc',
                yyOrderOptions: [{key: "zg.student_no", name: "按学号排序"}, {key: "zg.uddt desc", name: "按时间倒序"}],
                myCanvas: null, ctx: null, imgScale: 0.5, imgList: [], examImageList: [], isEdit: false,
                rules: null, isCollapse: false, selZgInfo: null, selPoint: null, selPointIndex: -1, scanPreResult: null, selMenu: null,
                baseSetting: { showStudentInfo: false, showAllExam: false, showKg: false},
                zgForm: {examId: null, teacherId: null, examSeq: null, idxCount: 1, nextExamSeq: null, studentId: null,
                subIndex: 0, totalCount: 0, status: null, inStatus: null, hardClassId: null, limit: null},
                defaultActive: ["root"],  examInfo: {}, totalCount: 0, yyCount: 0,
                menuData:[], searchMenu: null, searchIxList: [],
                zgSeqList: [], 
                zgYYSeqList: [], 
                hardSeqList: [], 
                teachingSeqList: [], 
                zgData: [],
                zgSeqYcList:[],
                activeIndex: null, hotIndex: -1, hotList: [], //快捷键列表
                //快捷打分，填空题
                isQuickScore: false, topicData: [], fillBlankList: [], quickExamSeq: null,
                drawMode: -1, drawList: [],
                caiDian: {
                  topicIndex: null, 
                  myScore: null, 
                  step: 1
                },
                // operInfo: {x: 250, y: 500},
                operInfo: {x: 0, y: 500},
                // 缩放比例
                scale: 1,
                // 被分配的行政班学生列表
                dialogVisible: false,
                loadingStudent: false,
                tableData: null,
                searchForm:{ 
                  pageNo: 1, 
                  pageSize: 50, 
                  totalCount: 0, 
                  searchText: null
                },
                // 选中下拉列表
                studentCheckList: {},
                selProgress: null, 
                idCountList: [],
                // 拼接图片的高度列表
                pageHeights:[],
                // 存疑任务保存下一位学生
                nextStudentId: null,
                // 是否自动调用下一位
                isNextByYC: false,
                nextStudentByYC: {}

            }
        },
        components:{
            ElImageViewer, rightPanel, operPanel, scorePoint, searchDialog, recentList,progressDialog
        },
        computed:{
            ...mapState({
                userInfo: state => state.user.userInfo,
            }),
            // // 计算缩放后的画布尺寸
            // canvasWidth() {
            //   return this.baseWidth * this.scale;
            // },
            // canvasHeight() {
            //   return this.baseHeight * this.scale;
            // }
        },
        created() {
            let myHeight = document.documentElement.clientHeight ;
            let myWidth = document.documentElement.clientWidth ;
            this.formStyle = {height: myHeight, width: myWidth};
            // console.log('myHeight:', myHeight);
            this.scoringStyle = {height: (myHeight) + 'px', border: "1px solid #eee"};
            this.mainStyle = {width: (myWidth-200) + 'px'}
            this.canvasWidth = myWidth -600;
            this.canvasHeight = myHeight - 450;

        },
      	mounted() {
            let examId = this.$route.query.e;
            // console.log("examId", examId);
            if(examId && examId != null){
                this.examId = parseInt(examId);
                this.zgForm.examId = parseInt(examId);
                this.zgForm.teacherId = this.userInfo.id;
                // 获得对应考试全部题号对应的idxCount
                this.getIdxCountByExamSeq()
            }

            let that = this;
            this.$nextTick(() => {
                that.menuHeight = document.documentElement.clientHeight-80;
                window.addEventListener("scroll", that.handleScroll, true);
                // 提前预设operInfo位置
                this.operInfo = {
                  x: Math.round(window.innerWidth * 0.5),
                  y: Math.round(window.innerHeight * 0.8)
              };
            });
          key('s', ()=>{ this.keyS()});
          key('w', ()=>{ this.keyW()});
	    },
        watch: {
            examId: {
                deep: true, immediate:true,
                handler(n, o){
                    // console.log(n)
                    if(n){
                        this.reload();
                    }
                }
            },
            drawMode: {
                deep: true, immediate:true,
                handler(n, o){
                    console.log('drawMode change', n);
                    let that = this;
                    //重置所有数据
                    if(n ==8){ 

                        this.examImageList = [];
                        this.selPoint = null;
                        if(this.scanPreResult != null){
                            if(this.scanPreResult.oss_full_name1 != null)this.examImageList.push(this.scanPreResult.oss_full_name1);
                            if(this.scanPreResult.oss_full_name2 != null) this.examImageList.push(this.scanPreResult.oss_full_name2);
                        }
                        if(this.isQuickScore){
                          for (let i=this.drawList.length-1; i>=0; i--){
                            let w = this.drawList[i];
                            if(w.type == 100){
                              // 清空分数的同时清空pointList(踩点记录)
                              w.score = 0;
                              w.pointList = []
                            }
                            else this.drawList.splice(i, 1)
                          }
                        }else{
                          this.drawList = [];
                        }
                        this.$refs.rightPanel.clearScore();
                        this.drawMode = -1;


                        
                    }
                    if(n == 9 || n == 10){
                        this.examImageList = [];
                        this.drawList = [];
                        if(this.zgForm.limit == null) {
                            this.zgForm.limit = 0;
                        } else{
                            // console.log(this.zgForm.limit, this.zgForm.idxCount)
                            if(n == 10) this.zgForm.limit = this.zgForm.limit + this.zgForm.idxCount;
                            if(n == 9 && this.zgForm.limit > 0) this.zgForm.limit = this.zgForm.limit - this.zgForm.idxCount;
                        }
                        this.loadZgExam();
                        this.drawMode = -1;
                    }
                    //删除标记
                    if(n ==5){ 
                        let that = this;
                        if(this.selPointIndex>-1){
                            let selPoint = this.drawList[this.selPointIndex];
                            // console.log('del', this.selPointIndex, selPoint.showX, selPoint.showY);
                            if(selPoint.type == 99){
                                // console.log('del selPoint', selPoint);
                                this.$refs.rightPanel.caidianScore(selPoint.topicIndex, 0-selPoint.score, false, true);
                            }
                            if(selPoint.type == 100){selPoint.score = 0; this.$refs.rightPanel.caidianScore(selPoint.topicIndex, 0, true, true); this.drawMode = -1; return;}
                            this.loading = true;
                            let myList = Object.assign(this.drawList);
                            myList.splice(this.selPointIndex, 1);
                            this.drawList = [];
                            setTimeout(function () {
                                that.drawList = myList;
                                // that.drawList.forEach((item, index) => {console.log(index, item.showX, item.showY)});
                              that.loading = false;
                            }, 800);
                        }
                        this.drawMode = -1;
                    }
                    if(n > 0 && "rightPanel" in this.$refs && this.$refs.rightPanel != null){
                        if(n != 99) this.$refs.rightPanel.makeTopicValue(null);
                    }
                    // drawMode = 100 情况变动时 重新加载下loadMarkRecord
                    if(n == 100){
                      this.loading = true
                      
                      setTimeout(() => {
                        this.loadMarkRecord()
                        this.loading = false
                      
                      }, 500);
                    }
                }
            },
            isCollapse: {
                deep: true, immediate: true,
                handler(n, o) {
                    let myHeight = document.documentElement.clientHeight ;
                    let myWidth = document.documentElement.clientWidth ;
                    if(!this.isCollapse){
                        this.asideWidth = "200px";
                        this.mainStyle.width = (this.formStyle.width - 200) + "px";
                        this.canvasWidth = myWidth -600;
                    }else{
                        this.asideWidth = "50px";
                        this.mainStyle.width = (this.formStyle.width - 50) + "px";
                        this.canvasWidth = myWidth -450;
                    }
                    this.drawList = [];
                    this.loadCanvas();
                    this.$set(this, "mainStyle", this.mainStyle);
                }
            },
        },
        methods: {
          keyS(){
            // // debugger
            if(this.isEdit && this.hotList != null && this.hotList.length > 0){
              this.hotIndex++;
              if(this.hotIndex >= this.hotList.length) this.hotIndex = 0
              this.menuClick(this.hotList[this.hotIndex], this.hotIndex, this.hotList)
              this.activeIndex = this.hotList[this.hotIndex].key;
            }
          },
          keyW(){
            // // debugger
            if(this.isEdit && this.hotList != null && this.hotList.length > 0){
              this.hotIndex--;
              this.menuClick(this.hotList[this.hotIndex], this.hotIndex, this.hotList)
              this.activeIndex = this.hotList[this.hotIndex].key;
            }
          },
            handleScroll(e) {
                if(("documentElement" in e.target) && ("scrollTop" in e.target.documentElement)){
                    let scrollTop = e.target.documentElement.scrollTop;
                    let offX = this.operInfo.x
                    let offY = this.operInfo.y

                    this.operInfo = {
                      x: offX  +0.00001,
                      y: offY  +0.00001 
                    };
                }
            },
            showAllChange(v){
              console.log("showAllChange", v)
              this.reload();
            },
            reload(){
                let that = this;
                this.loading = false;
                this.drawList = [];
                this.loadExam(function () {
                    that.loadExamTopic(function () {
                        that.loadMenu(function () {
                            that.zgForm.inStatus = ['01', '02'];
                            if(that.totalCount == 0){
                                that.$alert('您的阅卷已全部阅完', '提示');
                            }
                          that.loading = false;
                        });
                    });
                });
            },
            handleDrawerClose(done){
                done();
            },
            loadExamTopic(callback){
                let search = { teacherId: this.userInfo.id, licenceId:this.userInfo.licenceId ,examId: parseInt(this.examId), showAll: this.showAllChecked?1:0, yyOrderBy: this.yyOrderBy};
                if(this.rules != null && this.rules.hardClassList != null && this.rules.hardClassList.length > 0 ){
                    let hardClassList = [];
                    for (let i=0; i<this.rules.hardClassList.length; i++){
                        let d = this.rules.hardClassList[i];
                        hardClassList.push({id: d.hardClassId});
                    }
                    search["hardClassList"] = hardClassList;
                }
                if(this.rules != null && this.rules.teachingClassList != null && this.rules.teachingClassList.length > 0 ){
                    let teachingClassList = [];
                    for (let i=0; i<this.rules.teachingClassList.length; i++){
                        let d = this.rules.teachingClassList[i];
                        teachingClassList.push({id: d.id});
                    }
                    search["teachingClassList"] = teachingClassList;
                }

                let param = { controllerName: 'examTask', methodName: '/teacherTask',  param: search};
                return simpleApi.list(param).then(({result: {code, data}}) =>  {
                    console.log("loadExamTopic", code, data);
                    if (code == 0) {
                        this.zgSeqList = data.zgSeqList;
                        this.zgYYSeqList = data.zgYYSeqList;
                        this.zgSeqYcList = data.zgSeqYcList
                        if(data.zgCountMap){
                            this.totalCount = data.zgCountMap.w_cou;
                            this.yyCount = data.zgCountMap.yy_cou;
                        }
                        this.hardSeqList = [];
                        if(this.rules != null && this.rules.hardClassList != null && this.rules.hardClassList.length > 0 ){
                            let hardClassList = [];
                            for (let i=0; i<this.rules.hardClassList.length; i++){
                                let d = this.rules.hardClassList[i];
                                let hard = data[d.hardClassId];
                                if(hard){
                                    hardClassList.push({id: d.hardClassId, name: d.hardName, list: hard});
                                }
                            }
                            this.hardSeqList = hardClassList;
                        }
                        this.teachingSeqList = []
                        if(this.rules != null && this.rules.teachingClassList != null && this.rules.teachingClassList.length > 0 ){
                            let teachingSeqList = [];
                            for (let i=0; i<this.rules.teachingClassList.length; i++){
                                let d = this.rules.teachingClassList[i];
                                let hard = data[d.id];
                                if(hard){
                                    teachingSeqList.push({id: d.id, name: d.name, list: hard});
                                }
                            }
                            this.teachingSeqList = teachingSeqList;
                        }
                        if(callback) callback();

                    }

                }).catch((error) => {
                    console.log("error", error)
                });
            },
            loadExam(callback){
                let param = { controllerName: 'akExam', methodName: '/get',  param: {id: parseInt(this.examId)}};
                return simpleApi.list(param).then(({result: {code, data}}) =>  {
                    console.log("loadExam", code, data);
                    if (code == 0) {
                        this.examInfo = data;
                        if(data && data.rules != null){
                            this.rules = JSON.parse(data.rules);
                            this.baseSetting = this.rules.baseSetting;
                        }
                    }
                    if(callback) callback();
                }).catch((error) => {
                    console.log("error")
                });
            },
            // 加载侧边菜单栏
            // async
            loadMenu(callback){
                console.log("。。。计算菜单。。。。");
                this.menuData = [];
                let children = [];

                for (let i=0; i<this.zgSeqList.length; i++){
                    let d = this.zgSeqList[i];
                    if(d.yy_cou == d.cou) continue;
                    let examSeq = d.exam_seq;
                    let ixFind = XEUtils.find(this.searchIxList, item => item.exam_seq==d.exam_seq);
                    if(!ixFind) this.searchIxList.push({exam_seq: d.exam_seq})
                    if(examSeq.length > 7){
                        examSeq = examSeq.substr(0,2) + "..." + examSeq.substr(examSeq.length-2,examSeq.length-1);
                    }
                    // // debugger
                    // let idxCount = Math.ceil(d.all_cou / d.cou);
                    // console.log("d", d.exam_seq, d.all_cou, d.cou, idxCount)
                    let idxCount = this.idCountList[d.exam_seq] || 4

                    examSeq = examSeq + "(" + d.yy_cou + "/" + d.cou +")";
                    let nextExamSeq = ((i+1)<this.zgSeqList.length)?this.zgSeqList[i+1].exam_seq: null;
                    children.push({ name: examSeq, icon: "el-icon-user", key: 'zg-'+i, data: {examId: this.examId, examSeq: d.exam_seq, idxCount: idxCount, nextExamSeq: nextExamSeq, isEdit: false, inStatus: ['01', '02']}})
                }

                if(children.length > 0){
                    children = children.sort((a, b) => {
                      let seqA = a.data.examSeq, seqB = b.data.examSeq;
                      let arrA = seqA.split(","), arrB = seqB.split(",");
                      let vA = 0, vB = 0;
                      if(arrA.length > 1) vA = parseInt(arrA[0]); else vA = parseInt(seqA);
                      if(arrB.length > 1) vB = parseInt(arrB[0]); else vB = parseInt(seqB);
                      return vA - vB;
                    })
                    this.zgForm.totalCount = children.length;
                    let zgSeq = { name: "阅卷任务", icon: "el-icon-location", key: 'root', children: children};
                    this.menuData.push(zgSeq);
                }
                // 行政班列表 新增对应的学生列表
                if(this.hardSeqList && this.hardSeqList.length > 0){
                  // 判断是否显示学生列表
                    let studentCheckType = false
                    if(Object.keys(this.studentCheckList).length === 0 ) studentCheckType = false
                    for (let i=0; i<this.hardSeqList.length; i++){
                        let d = this.hardSeqList[i];
                        let hcChildren = [];
                        for (let j=0; j<d.list.length; j++){
                            let h = d.list[j];
                            let examSeq = h.exam_seq;
                            if(examSeq.length > 7){
                                examSeq = examSeq.substr(0,2) + "..." + examSeq.substr(examSeq.length-2,examSeq.length-1);
                            }
                            examSeq = examSeq + "(" + h.yy_cou + "/" + h.cou +")";
                            let idxCount = parseInt(h.all_cou / h.cou);
                            // 默认选中状态为false
                            /*
                            let checkType = false
                            let key =  'hc-'+i + "-" + j
                            if(studentCheckType) {
                              this.studentCheckList[key] = false
                            }else{
                              checkType = this.studentCheckList[key]
                            }
                            // 通过接口 获取到对应的学生列表
                            let search = {
                              examId : this.examId,
                              examSeq: h.exam_seq,
                              classId: d.id,
                              teacherId: this.userInfo.id,
                              type: 'hard'
                            }
                            let list = await this.getHardStudentByExam(search,idxCount)

                            hcChildren.push({ 
                              name: examSeq, 
                              icon: "el-icon-user",  
                              key: 'hc-'+i + "-" + j, 
                              data: {
                                examId: this.examId, 
                                examSeq: h.exam_seq, 
                                idxCount: idxCount, 
                                isEdit: true,  
                                hardClassId: d.id
                              },
                              children: list,
                              studentCheckType: checkType
                             })
                              */

                          hcChildren.push({ 
                            name: examSeq, 
                            icon: "el-icon-user",  
                            key: 'hc-'+i + "-" + j, 
                            data: {examId: this.examId, examSeq: h.exam_seq, idxCount: idxCount, isEdit: true,  hardClassId: d.id} })

                        }
                        let hardName = d.name;
                        if(hardName.length > 7){
                            hardName = hardName.substr(0,3) + "..." + hardName.substr(hardName.length-4,hardName.length-1);
                        }
                        let hc = { name: hardName, icon: "el-icon-menu",  key: 'hc-'+i, children: hcChildren}
                        if(hcChildren.length > 0)
                            this.menuData.push(hc);
                    }
                }

                // 教学班列表，新增对应的学生列表
                if(this.teachingSeqList && this.teachingSeqList.length > 0){
                    for (let i=0; i<this.teachingSeqList.length; i++){
                        // 判断是否显示学生列表
                        let studentCheckType = false
                        if(Object.keys(this.studentCheckList).length === 0 ) studentCheckType = true
                        let d = this.teachingSeqList[i];
                        let hcChildren = [];
                        for (let j=0; j<d.list.length; j++){
                            let h = d.list[j];
                            let examSeq = h.exam_seq;
                            if(examSeq.length > 7){
                                examSeq = examSeq.substr(0,2) + "..." + examSeq.substr(examSeq.length-2,examSeq.length-1);
                            }
                            examSeq = examSeq + "(" + h.yy_cou + "/" + h.cou +")";
                            let idxCount = parseInt(h.all_cou / h.cou);

                            /*
                            // 默认选中状态为false
                            let checkType = false
                            let key = 'tc-'+i + "-" + j
                            if(studentCheckType) {
                              this.studentCheckList[key] = false
                            }else{
                              checkType = this.studentCheckList[key]
                            }
                            // 通过接口 获取到对应的学生列表
                            let search = {
                              examId : this.examId,
                              examSeq: h.exam_seq,
                              classId: d.id,
                              teacherId: this.userInfo.id,
                              type: 'teaching'
                            }
                            let list = await this.getHardStudentByExam(search,idxCount)
                            hcChildren.push({ 
                              name: examSeq, 
                              icon: "el-icon-user",  
                              key: 'tc-'+i + "-" + j, 
                              data: {
                                examId: this.examId, 
                                examSeq: h.exam_seq, 
                                idxCount: idxCount, 
                                isEdit: true, 
                                teachingClassId: d.id
                              } ,
                              children: list,
                              studentCheckType: checkType
                            })*/

                            hcChildren.push({ 
                              name: examSeq, icon: "el-icon-user",  
                              key: 'tc-'+i + "-" + j, 
                              data: {examId: this.examId, examSeq: h.exam_seq, idxCount: idxCount, isEdit: true, teachingClassId: d.id} })

                        }



                        let hardName = d.name;
                        if(hardName.length > 7){
                            hardName = hardName.substr(0,3) + "..." + hardName.substr(hardName.length-4,hardName.length-1);
                        }
                        let hc = { name: hardName, icon: "el-icon-menu",  key: 'tc-'+i, children: hcChildren}
                        if(hcChildren.length > 0)
                            this.menuData.push(hc);
                    }
                }

                if(this.zgYYSeqList != null && this.zgYYSeqList.length > 0){
                    let children = [];
                    for (let i=0; i<this.zgYYSeqList.length; i++){
                        let d = this.zgYYSeqList[i];
                        let examSeq = d.exam_seq;
                        if(examSeq.length > 7){
                            examSeq = examSeq.substr(0,2) + "..." + examSeq.substr(examSeq.length-2,examSeq.length-1);
                        }
                        let ixFind = XEUtils.find(this.searchIxList, item => item.exam_seq==d.exam_seq);
                        if(!ixFind) this.searchIxList.push({exam_seq: d.exam_seq})

                        /*
                          跨页多题idxCount计算公式（已阅）
                        */ 
                        let idxCount = parseInt(d.all_cou / d.cou);
                        let zgStuList = d.zgList;
                        if(zgStuList != null && zgStuList.length > 0){
                            examSeq = "题"+examSeq + "(" + zgStuList.length +"条)";
                            let nextExamSeq = ((i+1)<this.zgYYSeqList.length)?this.zgYYSeqList[i+1].exam_seq: null;
                            let pchild = { 
                              name: examSeq, 
                              icon: "el-icon-user", 
                              key: 'zgyy-'+i,
                              data: {
                                examId: this.examId, 
                                examSeq: d.exam_seq, 
                                idxCount: idxCount, 
                                nextExamSeq: nextExamSeq, 
                                status: 'YY', 
                                isEdit: true, 
                                inStatus: null, 
                                children: null}
                              };

                            let stuChildren = [];
                            let zgStuLen = zgStuList.length;
                            for (let j=0; j<zgStuLen; j++){
                                let zgStu = zgStuList[j];
                                let stuChildName = (this.baseSetting.showStudentInfo)?(zgStu.student_name+"("+zgStu.student_no+")"):"学生"+(zgStuLen-j);
                                let item = { 
                                  name: stuChildName,  
                                  key: 'zgyy-'+i+zgStu.student_id, 
                                  isModify: (zgStu.power1>0||zgStu.power2>0),
                                  data: {
                                    examId: this.examId, 
                                    examSeq: d.exam_seq, 
                                    studentId: zgStu.student_id, 
                                    status: 'YY', 
                                    isEdit: true, 
                                    inStatus: null,
                                    idxCount: idxCount
                                  }
                                }
                                if (j===0){
                                  item['first'] = true
                                }
                                stuChildren.push(
                                    item
                                    )
                            }
                            pchild.children = stuChildren;
                            children.push(pchild);
                        }

                    }
                    // // debugger
                    if(children.length > 0){
                        children = children.sort((a, b) => {
                          let seqA = a.data.examSeq, seqB = b.data.examSeq;
                          let arrA = seqA.split(","), arrB = seqB.split(",");
                          let vA = 0, vB = 0;
                          if(arrA.length > 1) vA = parseInt(arrA[0]); else vA = parseInt(seqA);
                          if(arrB.length > 1) vB = parseInt(arrB[0]); else vB = parseInt(seqB);
                          return vA - vB;
                        })
                        let zgSeq = { name: "已阅任务", icon: "el-icon-edit", key: 'yyRoot', children: children};
                        this.menuData.push(zgSeq);
                    }
                }
                if(this.zgSeqYcList != null && this.zgSeqYcList.length > 0){
                  debugger
                    let children = [];
                    for (let i=0; i<this.zgSeqYcList.length; i++){
                        let d = this.zgSeqYcList[i];
                        let examSeq = d.exam_seq;
                        if(examSeq.length > 7){
                            examSeq = examSeq.substr(0,2) + "..." + examSeq.substr(examSeq.length-2,examSeq.length-1);
                        }
                        let ixFind = XEUtils.find(this.searchIxList, item => item.exam_seq==d.exam_seq);
                        if(!ixFind) this.searchIxList.push({exam_seq: d.exam_seq})

                        /*
                          跨页多题idxCount计算公式
                        */ 
                        let idxCount = parseInt(d.all_cou / d.cou);
                        let zgStuList = d.zgList;
                        if(zgStuList != null && zgStuList.length > 0){
                            examSeq = "题"+examSeq + "(" + zgStuList.length +"条)";
                            let nextExamSeq = ((i+1)<this.zgSeqYcList.length)?this.zgSeqYcList[i+1].exam_seq: null;
                            let pchild = { 
                              name: examSeq, 
                              icon: "el-icon-user", 
                              key: 'zgyc-'+i,
                              data: {examId: this.examId, examSeq: d.exam_seq, idxCount: idxCount, nextExamSeq: nextExamSeq, status: 'YY', isEdit: true, inStatus: null, children: null}
                            };
                            let stuChildren = [];
                            let zgStuLen = zgStuList.length;
                            for (let j=0; j<zgStuLen; j++){
                                let zgStu = zgStuList[j];
                                let stuChildName = (this.baseSetting.showStudentInfo)?(zgStu.student_name+"("+zgStu.student_no+")"):"学生"+(zgStuLen-j);
                                let item = { 
                                  name: stuChildName,  
                                  key: 'zgyc-'+i+zgStu.student_id, 
                                  isModify: (zgStu.power1>0||zgStu.power2>0),
                                  data: {examId: this.examId, examSeq: d.exam_seq, studentId: zgStu.student_id, status: 'YY', isEdit: true, inStatus: null}
                                }
                                if (j===0){
                                  item['first'] = true
                                }
                                stuChildren.push(item)

                                if(j == 0 && this.isNextByYC){
                                  // 如果是存疑异常且存疑自动提交 就默认读取第一位
                                  this.nextStudentByYC[d.exam_seq] = zgStu.student_id
                                }
 
                            }
                            pchild.children = stuChildren;
                            children.push(pchild);
                        }

                        


                    }
                    // 统计任务数 并添加存疑任务菜单
                    if(children.length > 0){
                      // debugger
                        children = children.sort((a, b) => {
                          let seqA = a.data.examSeq, seqB = b.data.examSeq;
                          let arrA = seqA.split(","), arrB = seqB.split(",");
                          let vA = 0, vB = 0;
                          if(arrA.length > 1) vA = parseInt(arrA[0]); else vA = parseInt(seqA);
                          if(arrB.length > 1) vB = parseInt(arrB[0]); else vB = parseInt(seqB);
                          return vA - vB;
                        })
                        let zgSeq = { name: "存疑任务", icon: "el-icon-s-unfold", key: 'ycRoot', children: children};
                        this.menuData.push(zgSeq);
                    }
                }
    
                if(this.searchMenu != null){
                    this.menuData.push(this.searchMenu);
                }

                // // debugger
                if(callback) callback();
            },
            searchStudentOK(s){
                this.loading = true;
                let that = this;
                let param = { controllerName: 'examTask', methodName: '/studentByTotalScore',
                    param: {examId: parseInt(this.examId), yy: 'no', studentName: s.studentName, studentNo: s.studentNo, teacherId: this.userInfo.id, examSeq: s.examSeq,
                        licenceId: this.userInfo.licenceId, fromScore: XEUtils.toNumber(s.scoreFrom),fromEachScore: XEUtils.toNumber(s.scoreEachFrom), toScore: XEUtils.toNumber(s.scoreTo),toEachScore: XEUtils.toNumber(s.scoreEachTo)}};
                this.searchMenu = null;
                return simpleApi.list(param).then(({result: {code, data}}) =>  {
                    console.log("searchStudentOK", code, data);
                    if (code == 0 && data && data.length > 0) {
                      let totalLen = data.length 
                        let name = "搜索结果(" + totalLen + "人)" 
                        let m = {name: name, icon: "el-icon-search", key: 'searchRoot', children: []}

                        let studentList = [];
                        for (let i=0; i<data.length; i++){
                            let d = data[i];
                            let children = [];
                            if(d.examSeqList && d.examSeqList.length > 0){
                                for (let j=0; j<d.examSeqList.length; j++){
                                  // // debugger
                                    let e = d.examSeqList[j];

                                    let examSeq = e.exam_seq;
                                    let idxCount = this.idCountList[e.exam_seq] || 4

                                    if(examSeq.length > 7) examSeq = examSeq.substr(0,2) + "..." + examSeq.substr(examSeq.length-2,examSeq.length-1);
                                    examSeq = examSeq + "(" + e.cou +"块)";
                                    children.push({ 
                                      name: examSeq, 
                                      icon: "el-icon-user", 
                                      key: 'stuyy-'+j,
                                      data: {
                                        examId: this.examId, 
                                        examSeq: e.exam_seq, 
                                        // idxCount: e.idx_cou, 
                                        idxCount: idxCount, 
                                        studentId: d.student_id, 
                                        isEdit: true, 
                                        inStatus: null
                                      }
                                    })
                                }
                            }
                            if(children.length > 0) studentList.push({ name: d.student_name+"(" + d.total_score + "分)", icon: "el-icon-user", key: 'stu-'+i, children: children});
                        }
                        if(studentList.length > 0){
                          m.children = studentList;
                          this.searchMenu = m;
                          console.log("searchStudentOK", m);
                          let mfIndex = XEUtils.findIndexOf(this.menuData, item => { return item.key == 'searchRoot'; });
                          if(mfIndex > -1) {
                              this.menuData.splice(mfIndex, 1);
                              setTimeout(function () {
                                  that.menuData.push(m);
                              }, 300);
                          } else {
                              this.menuData.push(m);
                          }
                        }

                    }
                    this.loading = false;
                }).catch((error) => {
                    console.log("error", error);
                    this.loading = false;
                });
            },
            // 侧边栏缩放 
            setMenuCollapse(){
                this.isCollapse = !this.isCollapse;
            },
            showExamName(examName){
                if(examName.length > 12)
                    return  examName.substr(0,6) + "..." + examName.substr(examName.length-6,examName.length-1);
                return examName;
            },
            menuClick(item, subIndex, hotList){
              debugger
                console.log("menuClick", item);
                this.selMenu = item;
                this.examImageList = [];
                this.drawList = [];
                this.zgForm.examSeq = item.data.examSeq;
                if(this.quickExamSeq != item.data.examSeq) this.fillBlankList = [] //如果不是同个主观题，则清除原先摆好的位置
                this.quickExamSeq = item.data.examSeq

                // // debugger
                if(("idxCount" in item.data)) this.zgForm.idxCount = item.data.idxCount; else this.zgForm.idxCount = 4;
                console.log("this.zgForm.idxCount ================> ", this.zgForm.idxCount);
                console.log("item.data.idxCount ================> ", item.data.idxCount);
                if("isEdit" in item.data) this.isEdit = item.data.isEdit; else this.isEdit = false;
                if(this.isEdit){
                  this.hotList = hotList;
                  this.hotIndex = subIndex;
                }
                this.zgForm.nextExamSeq = item.data.nextExamSeq;
                this.zgForm.status = item.data.status;
                this.zgForm.inStatus = item.data.inStatus;
                this.zgForm.subIndex = subIndex;
                this.zgForm.hardClassId = item.data.hardClassId;
                this.zgForm.teachingClassId = item.data.teachingClassId;
                if(("studentId" in item.data)) {
                    this.zgForm.studentId = item.data.studentId;
                    this.zgForm.teacherId = null;
                } else {
                    this.zgForm.studentId = null;
                    this.zgForm.teacherId = this.userInfo.id;
                }
                if(item.data.status == 'YY') this.zgForm.limit = 0; else this.zgForm.limit = null;

                // debugger
                // 判断是否是存疑任务，是存疑任务就默认保存下一位学生id 
                if(this.selMenu.key.includes('zgyc-')) {
                  // 默认暂不跳转 等点击存疑保存时启动
                  this.isNextByYC = false
                  // this.nextCYTask = false
                  // 当前的索引值 自动+1 但是判断是否超出hotList长度（检查是否是最后一位）
                  // this.nextStudentId = null
                  // let index = subIndex + 1
                  // if(index < hotList.length - 1) {
                  //   let ele  = hotList[index]
                  //   this.nextStudentId = ele.data.studentId
                  // }
                  
                }
                this.loadZgExam();
            },
            recentClick(row){
                console.log("recentClick", row);
                this.examImageList = [];
                this.drawList = [];
                this.zgForm.examSeq = row.exam_seq;
                this.zgForm.studentId = row.student_id;
                this.zgForm.idxCount = row.idxCount;
                this.zgForm.status = "YY";
                this.zgForm.inStatus = null;
                this.zgForm.teacherId = this.userInfo.id;
                this.zgForm.limit = null;
                this.loadZgExam();
            },
            loadZgExam(type){
                // debugger
                this.loading = true;
                let params = { ...this.zgForm }
                // 判断是否是存疑记录这边跳过来的调用,是的话不带状态就只查询对应学生（全部已阅情况下带status会触发最后一题检查）
                if(this.selMenu.key.includes('zgyc-')){
                  debugger
                  params.status = null
                  // 如果加载zg题目时 type ='zgyc' 且菜单点击时是异常 就携带下一位学生id加载
                  if(type =='zgyc') {
                    // 获取下一位学生
                    let seq = this.selZgInfo.examSeq
                    params.studentId = this.nextStudentByYC[seq]
                  }
                  // this.nextStudentByYC[examSeq] = zgStu.student_id
                } 
                // 新增licence_id
                params.licenceId = this.userInfo.licenceId
                // let param = { controllerName: 'examTask', methodName: '/getZgList',  param: this.zgForm};
                let param = { controllerName: 'examTask', methodName: '/getZgList',  param: params};
                this.zgData = [];
                let that = this;
                return simpleApi.list(param).then(({result: {code, data}}) =>  {
                    console.log("loadExam", code, data);
                    if (code == 0 && data && data.length > 0) {
                        let first = data[0];
                        this.selZgInfo = {
                          examId: first.exam_id, 
                          examSeq: first.exam_seq, 
                          studentId: first.student_id, 
                          scanFileId: first.scan_file_id,
                          studentNo: first.student_no, 
                          studentName: first.student_name, 
                          kgScore: first.kg_score, 
                          zgIds: [first.id], 
                          teacherId: first.teacher_id, 
                          isQuickScore: first.isQuickScore,
                          markRecords: [first.mark_record], 
                          drawImgs: [first.draw_img], 
                          status: first.status, 
                          abPaper: first.ab_paper,
                          seqAverageScore:null,
                          examScoreType:null 
                        }
                        if(data.length == 1) {
                          this.zgData = data;
                        }else{
                          this.zgData = [];
                          this.selZgInfo.zgIds = [];
                            this.selZgInfo.markRecords = [];
                            this.selZgInfo.drawImgs = [];
                          for (let i=0; i<data.length; i++){
                            let ed = data[i];
                            if(first.student_id == ed.student_id){
                              this.zgData.push(ed);
                              this.selZgInfo.zgIds.push(ed.id);
                              this.selZgInfo.markRecords.push(ed.mark_record);
                              this.selZgInfo.drawImgs.push(ed.draw_img);
                            }
                          }
                        }
                        this.loadCanvas();
                        this.loadFullExam();
                        // 查看教师批阅平均分
                        // this.getAverageScore();

                        //this.initEachLicenceConfig();
                    }else{
                        if(code == 11){
                            this.$alert('您的阅卷已全部阅完', '提示');
                        }else if(code == 12){
                            this.$alert('题块:'+this.zgForm.examSeq+'，已到最后一题', '提示');
                            this.zgForm.limit = 0;
                        }else if(code == 13){
                            this.$confirm('本题批阅任务已完成，是否批阅剩余阅卷任务？', '提示', {
                                confirmButtonText: '是', cancelButtonText: '否', type: 'warning'
                            }).then(() => {
                                if(that.menuData[0].key == 'root'){
                                    let subChildren = that.menuData[0].children;
                                    this.zgForm.subIndex = this.zgForm.subIndex + 1;
                                    if(this.zgForm.subIndex > this.zgForm.totalCount) this.zgForm.subIndex = 0;
                                    let mySub = subChildren[this.zgForm.subIndex];
                                    that.menuClick(mySub, this.zgForm.subIndex);
                                }

                            }).catch(() => {

                            });
                        }
                        this.examImageList = [];
                        this.drawList = [];
                        // this.$set(this, 'drawList', []);
                        this.selZgInfo = null;
                        this.clearCanvas();
                        this.loading = false;
                    }

                }).catch((error) => {
                    console.log("error", error);
                    this.loading = false;
                });
            },
          getAverageScore(){
            // console.log("cxh:examId",this.examId);
            // console.log("cxh:examSeq",this.zgForm.examSeq);
            // console.log("cxh:teacherId",this.userInfo.id);
            let search = { examId: this.examId, licenceId:this.userInfo.licenceId,examSeq: this.zgForm.examSeq,teacherId:this.userInfo.id,status:"YY"}
            let param = { controllerName: 'examTask', methodName: '/getTeacherSeQAverageScore', param: search};
            simpleApi.post(param).then(({ result: { code, data}, sysCode}) => {
              if(data){
                this.selZgInfo.seqAverageScore = data.seqAverageScore;
              }
            });
          },
          initEachLicenceConfig(){
            // let search = { licenceId: this.userInfo.licenceId}
            let search = { licenceId: "95e6ce3c6fc0412ba2d27586d030c3f4",sysCode:"EXAM_SCORE"}

            let param = { controllerName: 'examTask', methodName: '/initEachLicenceConfig', param: search};
            simpleApi.post(param).then(({ result: { code, data}, sysCode}) => {
              if(data){
                this.selZgInfo.examScoreType = data.sysValue;
              }else{
                this.selZgInfo.examScoreType = 2;
              }
            });
          },
            loadFullExam(){
                if(this.baseSetting.showAllExam){
                    let that = this;
                    let search = { licenceId: this.userInfo.licenceId, examId: this.selZgInfo.examId, studentId: this.selZgInfo.studentId};
                    let param = { controllerName: 'scan/scanPreResult', methodName: '/list',  param: search};
                    return simpleApi.list(param).then(({result: {code, data}}) =>  {
                        if (data && data.result && data.result.length > 0) {
                            console.log("scanPreResult", data);
                            let scanPreResult = data.result[0];
                            this.scanPreResult = scanPreResult;
                            if(scanPreResult.oss_full_name1 != null){
                                this.examImageList.push(scanPreResult.oss_full_name1);
                            }
                            if(scanPreResult.oss_full_name2 != null){
                                this.examImageList.push(scanPreResult.oss_full_name2);
                            }
                        }
                    }).catch((error) => {
                        console.log("error", error)
                    });
                }
            },
            submitNext(){
                this.examImageList = [];
                this.loadZgExam();
                this.drawMode = -1;
            },
            reEdit(){
              console.log("?????????????-reEdit-?????????????");
                for (let i=0; i<this.drawList.length; i++){
                  let d = this.drawList[i]
                  d["power"] = 0;
                  d["color"] = 'red';
                }
            },
            // 直接打分，踩点打分，多维度打分 初始化（快捷打分）
            quickScoreAction(o){
              debugger
              let {show, topicType, topicData, reset} = o;
              this.isQuickScore = show;
              this.topicType = topicType
              this.topicData = []
              let that = this;
              if(!this.myCanvas) return;
              let rect = this.myCanvas.getBoundingClientRect();
              let canLeft = rect.left, canTop = rect.top, canWidth = rect.width, canHeight = rect.height;
              if(reset){ 
                // // debugger
                //填空题 打分框 复原位置
                this.getFillBlankByYY(topicData,canLeft,canTop,canWidth,canHeight)
                // this.drawList = []
                // for (let i=0; i<topicData.length; i++) {
                //   let t = topicData[i]
                //   let x = canLeft + (i%3)*120 + 10, y = canTop + parseInt(i/3) * 40+5;
                //   // let ixIdx = XEUtils.findIndexOf(this.drawList, item => (item.type == 100 && item.topicIndex==t.topicIndex));
                //   let o = { 
                //     index: this.drawList.length, 
                //     w: 80, h: 40, x: x, y: y, scaleX: x, scaleY: y, 
                //     topicIndex: t.topicIndex,
                //     showX: x, showY: y, 
                //     type: 100, 
                //     score: 0, scoreStep: 0.5, rightScore: t.rightScore, 
                //     isR: true, isD: true, move: true};
                //   // if(ixIdx > -1){
                //   //   o.score = this.drawList[ixIdx].score;
                //   //   this.drawList.splice(ixIdx, 1)
                //   // }
                //   setTimeout(()=>{
                //     that.drawList.push(o)
                //   }, 500);
                // }
              }else{
                
                // // debugger
                for (let i=this.drawList.length-1; i>=0; i--){
                  // 多道填空题踩点打分模式 清除pointList 时同时清除分数
                  // if(this.drawList[i].type == 100) this.drawList.splice(i, 1)


                  // 多道填空题的踩点打分模式 仅清除pointList
                  // if(this.drawList[i].type == 100){
                  //   this.drawList[i].score = 0
                  //   this.drawList[i].pointList = []


                  // } 
                  // 普通/ 多题 填空题踩点打分数据清除
                  if(this.drawList[i].type == 99 || this.drawList[i].type == 100) this.drawList.splice(i, 1)

                }
               if(!show){
                  // if("rightPanel" in this.$refs) this.$refs.rightPanel.clearScore();
                }else if(topicType=='FillBlank'){
                  debugger
                  this.topicData = topicData;
                  for (let i=0; i<topicData.length; i++){
                    let t = topicData[i]
                    let ixFind = XEUtils.find(this.fillBlankList, item => item.topicIndex==t.topicIndex);
                    // console.log('quickA', t.topicIndex, this.fillBlankList);
                    if(ixFind){
                      this.drawList.push(ixFind)
                    }else{
                      debugger
                      // -------------------------------------------- 填空题多题踩点打分模式（100）------------------------------------------------------------------------------------
                      // 填空题踩点打分模式（100）
                      let x = canLeft + (i%3)*120 + 10, y = canTop + parseInt(i/3) * 40+5;
                      let o = { 
                        index: this.drawList.length, 
                        w: 80, h: 40, x: x, y: y, scaleX: x, scaleY: y, 
                        topicIndex: t.topicIndex,
                        showX: x, showY: y, 
                        type: 100, 
                        score: 0, 
                        scoreStep: 0.5, 
                        rightScore: t.rightScore, 
                        isR: true, isD: true, move: true,
                        pointList:[],
                        // 默认批阅是红色
                        color: 'indianred'
                      };
                      // console.log('quickScoreAction', x, y, o);
                      this.drawList.push(o)
                    }
                  }
                }
              }
            },
            quickScoreSet(id, arrIdx){
              let selPoint = this.drawList[arrIdx];
              this.selPointIndex = arrIdx;
              // 踩点打分时，侧边栏的题号选中与切换
              if(this.drawMode == 99 && this.caiDian && XEUtils.isNumber(this.caiDian.myScore)){
                console.log("quickScore ---- quickScoreSet");
                if(selPoint.type  === 100){
                  // clientX,clientY仅作为填空题踩点打分时使用

                  // 填空题的踩点作答分数不从侧边打分步长处取，取得步长的值
                  // let myScore = parseFloat(this.caiDian.myScore)
                  // selPoint["score"] = myScore;
                  // let calcScore = myScore
                  // if(myScore<0) calcScore = this.caiDian.rightScore + myScore;
                  // this.$refs.rightPanel.caidianScore(selPoint.topicIndex, calcScore, true);


                }else{
                  let myScore = parseFloat(this.caiDian.myScore)
                  selPoint["score"] = myScore;
                  let calcScore = myScore
                  if(myScore<0) calcScore = this.caiDian.rightScore + myScore;
                  this.$refs.rightPanel.caidianScore(selPoint.topicIndex, calcScore, true);
                }


              }
            },
          spDeleteMe(id, arrIdx){
            console.log("spDeleteMe", id, arrIdx)
            this.selPointIndex = arrIdx;
            this.drawMode = 5

          },
            loadCanvas(){
                let that = this;
                this.imgList = [];
                // 存储每张图的高度信息(多图拼接的情况下)
                this.pageHeights = [];  
                this.$nextTick(() => {
                    if(that.zgData == null || that.zgData.length < 1) return ;
                    let canvas = document.getElementById("myCanvas1");
                    console.log("loadCanvas ", that.zgData, that.canvasWidth, that.canvasHeight)
                    
                    if(canvas.getContext){

                        this.myCanvas = canvas;
                        let ctx = canvas.getContext('2d');
                        this.ctx = ctx;
                        this.ctx.scale(this.scale,this.scale)

                        let myCount = 0;
                        
                        for (let i=0; i<that.zgData.length; i++){
                            let ed = that.zgData[i];
                            let img = new Image();
                            console.log("ed ", i, ed)
                            img.src = mUtils.urlAddTimestamp(window.g.OSS_HOST + ed.oss_name);
                            that.examImageList.push(img.src);
                            that.imgList.push({img: img, width: 0, height: 0});
                            
                            img.onload = function () {
                                that.imgList[i].width = this.width * that.scale;
                                that.imgList[i].height = this.height * that.scale;
                                
                                that.pageHeights[i] = {
                                    pageIndex: i,
                                    height: that.imgList[i].height,
                                    yOffset: 0
                                };
                                // // debugger
                                // that.drawImage(i);
                                // 绘制踩点打分与打分框(that.drawImage)
                                if(that.zgData.length == (myCount+1)) {
                                  that.drawImage(i); 
                                  let cumulativeY = 0;

                                  for (let j = 0; j < that.pageHeights.length; j++) {
                                      that.pageHeights[j].yOffset = cumulativeY;
                                      cumulativeY += that.pageHeights[j].height;
                                  }
                                  that.pageHeights.totalHeight = cumulativeY;
                                  console.log('每张图高度信息:', that.pageHeights);
                                
                                }else { 
                                  myCount = myCount + 1
                                }
                              }
                        }
                    }
                });
            },
            clearCanvas(){
                let w = this.myCanvas.getBoundingClientRect().width;
                let h = this.myCanvas.getBoundingClientRect().height;
                let ctx = this.myCanvas.getContext('2d');
                ctx.clearRect(0, 0, w, h);
            },
            drawImage(imgIndex, setScale){
              let myWidth=0, myHeight=0;
              for (let i=0; i<this.imgList.length; i++){
                let myImg = this.imgList[i];
                myWidth = myImg.width;
                myHeight = myHeight + myImg.height;
                console.log('myHeight', i, myHeight, myImg.height);
              }
              if(!setScale){
                let scale = 1;
                if(myWidth > this.canvasWidth){
                    console.log('myWidth', myHeight, myWidth);
                    scale = this.canvasWidth/myWidth;
                    this.ctx.width = myWidth * scale;
                    this.ctx.height = myHeight * scale;
                    this.imgScale = scale;
                    console.log("scale ", scale)
                }else{
                    this.ctx.width = myWidth;
                    this.ctx.height = myHeight;
                }
                this.myCanvas.width = this.ctx.width;
                this.myCanvas.height = this.ctx.height;
                console.log("drawImage", this.ctx.width, this.ctx.height)
                let dy = 0;
                for (let i=0; i<this.imgList.length; i++){
                  let myImg = this.imgList[i];
                  let imgWidth = myImg.width*scale;
                  let imgHeight = myImg.height*scale;
                  this.ctx.drawImage(myImg.img, 0, dy, imgWidth, imgHeight);
                    console.log("ctxdraw Image", 0, dy, imgWidth, imgHeight)
                  this.selZgInfo["zg"+(i+1)] = {x: 0, y: dy, width: imgWidth, height: imgHeight};
                  dy = dy + imgHeight;
                }
                console.log("selZgInfo", this.selZgInfo)
              }
              let that = this;
              // this.operInfo = {x: this.myCanvas.getBoundingClientRect().left+this.myCanvas.getBoundingClientRect().width-80, y: document.documentElement.clientHeight-100};
              // this.operInfo = {x: this.myCanvas.getBoundingClientRect().left+this.myCanvas.getBoundingClientRect().width * 0.65, y: document.documentElement.clientHeight*0.8};
              // this.operInfo = {
              //     x: Math.round(window.innerWidth * 0.5),
              //     y: Math.round(window.innerHeight * 0.8)
              // };
              console.log("operInfo ===>",this.operInfo);
              setTimeout(function (){
                // debugger
                // 加载markRecord
                that.loadMarkRecord(imgIndex,function (){
                  that.loading = false;
                });
              }, 500)

            },
            // 加载drewRecord 列表(使用mark_record)
            loadMarkRecord(imgIndex, callback){
              let that = this;
              // debugger
                if(this.selZgInfo.status == 'YY'){
                    // 提前清空
                    this.drawList = [];

                    let markRecords = this.selZgInfo.markRecords;

                    if(markRecords != null && markRecords.length > 0){
                      // 判断markRecord 是否有重复的topicindex + index
                      let a = this.selZgInfo
                      
                      
                      // debugger
                  
                      let isDuplicate = false
                      // 进填空题踩点打分模式进行判断
                      if(this.drawMode == 100) isDuplicate = this.checkDuplicateIndexTopicByInfo(a)
                      if(!isDuplicate){
                        // 不存在重复的数据
                        let gu = 121;
                        let myHeight = document.documentElement.clientHeight
                        for (let i=0; i< markRecords.length; i++){

                            if(markRecords[i] != null){
                
                                  let mrjson = JSON.parse(markRecords[i]);
                                  let zgInfo = this.selZgInfo["zg"+(i+1)];
                                  console.log('loadMarkRecord'+i, zgInfo, mrjson);

                                  let rect = this.myCanvas.getBoundingClientRect();
                                  let canLeft = rect.left
                                  let canTop = rect.top
                                  let canWidth = rect.width
                                  let canHeight = rect.height

                                  console.log("getBoundingClientRect", canLeft, canTop, canWidth, canHeight);

                                  if(canTop <0) canTop = 120;
                                  if("points" in mrjson && mrjson.points.length > 0){
                                    // // debugger
                                    for (let i=0; i<mrjson.points.length; i++){
                                      let m = mrjson.points[i];
                                      let o = null;
                                      // // debugger
                                      // 什么玩意
                                      let showY = canHeight * suoXiao(m.scaleY) + gu;
                                      let showX = canLeft + canWidth*suoXiao(m.scaleX)
                                      // console.log("什么玩意 ==> showX==>",showX);
                                      // console.log("什么玩意 ==> showY==>",showY);

                                      o = Object.assign(m, {showX: showX, showY: showY});

                                      if(m.type == 4 && "wenziText" in m){
                                              let pw =  m.wenziText.length * 20;
                                              o.w = 40+pw;
                                              console.log("wenziText", m.wenziText, o)
                                      }
                                      // console.log(i+1, "oldShowY", showY, "x:", o.x, 'y:', o.y, 'showX:', o.showX, 'showY:', o.showY, 'scaleX:', m.scaleX, m.scaleX1, 'scaleY:', m.scaleY, o);
                                      // 假设打分位置重叠，则打分标记只用一个（分数不同，在后边计算踩点打分的分数与实际分数的比较）
                                      // // debugger
                                      let isExist = false;
                                      for (let k=0; k<this.drawList.length; k++){
                                        let dl = this.drawList[k]
                                        if(dl.x == o.x && dl.y == o.y){
                                          isExist = true
                                          break;
                                        }
                                      }
                                      if(!isExist) {
                                        // 因为批阅记录需要居中摆放，暂定跟xy一致？ 会导致显示的位置偏移
                                        console.log("");
                                        // o.showX = o.x
                                        // o.showY = o.y
                                        this.drawList.push(o);
                                      }
                                    }
     
                                  }
                            }
                        }
                      }else{
                        // // debugger
                        // 重复的情况进行去重并重新计算分数
                        let gu = 121;
                        let myHeight = document.documentElement.clientHeight
                        let rect = this.myCanvas.getBoundingClientRect();
                        let canLeft = rect.left
                        let canTop = rect.top
                        let canWidth = rect.width
                        let canHeight = rect.height
                        
                        //  按 topicIndex 去重
                        let uniqueMap = new Map();
                        
                        for (let idx=0; idx<markRecords.length; idx++){
                            if(markRecords[idx] != null){
                                let mrjson = JSON.parse(markRecords[idx]);
                                let zgInfo = this.selZgInfo["zg"+(idx+1)];
                                console.log('loadMarkRecord'+idx, zgInfo, mrjson);
                                
                                console.log("getBoundingClientRect", canLeft, canTop, canWidth, canHeight);
                                if(canTop < 0) canTop = 120;
                                
                                if("points" in mrjson && mrjson.points.length > 0){
                                    
                                    for (let j=0; j<mrjson.points.length; j++){
                                        let m = mrjson.points[j];
                                        
                                        // 计算显示位置
                                        let showY = canHeight * suoXiao(m.scaleY) + gu;
                                        let showX = canLeft + canWidth * suoXiao(m.scaleX);
                                        console.log("showX==>", showX);
                                        console.log("showY==>", showY);
                                        
                                        let o = Object.assign({}, m, {showX: showX, showY: showY});
                                        
                                        if(m.type == 4 && "wenziText" in m){
                                            let pw = m.wenziText.length * 20;
                                            o.w = 40 + pw;
                                            console.log("wenziText", m.wenziText, o);
                                        }
                                        // 以 topicIndex 去重，保留有 pointList 的
                                        let existing = uniqueMap.get(o.topicIndex);
                                        if(!existing){
                                            uniqueMap.set(o.topicIndex, o);
                                        }else{
                                            // 保留有 pointList 的
                                            if(o.pointList && o.pointList.length > 0 && (!existing.pointList || existing.pointList.length === 0)){
                                                uniqueMap.set(o.topicIndex, o);
                                            }
                                        }
                                    }
                                }
                            }
                        }
                        
                        
                        for (let o of uniqueMap.values()){
                            this.drawList.push(o);
                        }

                        // 防止重复导致的分数不对 以去重后的drawList 为准 重新更新下markrecord的题目对应分数
                        // 再根据 drawList 中的 pointList 更新 markRecords 中的分数
                        if(markRecords && markRecords.length > 0){
                            for (let idx=0; idx<markRecords.length; idx++){
                                if(markRecords[idx] != null){
                                    let mrjson = JSON.parse(markRecords[idx]);
                                    if(mrjson.scoreInfo && mrjson.scoreInfo.topicData){
                                        let topicData = mrjson.scoreInfo.topicData;
                                        for (let i=0; i<this.drawList.length; i++){
                                            let point = this.drawList[i];
                                            if(point.pointList && point.pointList.length > 0){
                                                let totalScore = 0;
                                                for (let j=0; j<point.pointList.length; j++){
                                                    totalScore += point.pointList[j].score || 0;
                                                }
                                                let tfind = XEUtils.find(topicData, item => item.topicIndex == point.topicIndex);
                                                if(tfind){
                                                    tfind.score = totalScore;
                                                }
                                            }
                                        }
                                        // // debugger
                                        let totalScore = 0;
                                        for (let i=0; i<topicData.length; i++){
                                            totalScore += topicData[i].score || 0;
                                        }
                                        // // debugger
                                        mrjson.scoreInfo.score = totalScore;
                                        // // debugger
                                        // 把更新后的数据存回去
                                        markRecords[idx] = JSON.stringify(mrjson);
                                        this.$set(markRecords, idx, JSON.stringify(mrjson));
                                    }
                                }
                            }
                        }

                      }
                    }
                    // // debugger
                }else{
                  debugger
                  // 重新加载填空题的打分框
                  if(this.isQuickScore){
                    if(this.fillBlankList.length > 0){
                      // 防止误点击出现的方框
                      let fillBlankList =  this.fillBlankList.filter(item => 'topicIndex' in item)
                      // 再次清空drawList
                      this.drawList = []
                      for (let i=0; i< fillBlankList.length; i++){
                        let item = JSON.parse(JSON.stringify(fillBlankList[i]))
                        if(item.type == 100) item.pointList = []
                        this.drawList.push(item)
                        // this.drawList.push(JSON.parse(JSON.stringify(this.fillBlankList[i])))
                      }
                    }
                  }
                }
                if(callback) callback();
            },
            loadMarkRecord2(imgIndex, callback){
              let that = this;
              if(this.selZgInfo.status == 'YY'){

                  // 清空标记
                  this.drawList = [];
                  // // debugger
                  let markRecords = this.selZgInfo.markRecords;
                  if(markRecords != null && markRecords.length > 0){
                      let gu = 121;
                      let myHeight = document.documentElement.clientHeight
                      let rect = this.myCanvas.getBoundingClientRect();
                      let canLeft = rect.left
                      let canTop = rect.top
                      let canWidth = rect.width
                      let canHeight = rect.height
                      
                      //  按 topicIndex 去重
                      let uniqueMap = new Map();
                      
                      for (let idx=0; idx<markRecords.length; idx++){
                          if(markRecords[idx] != null){
                              let mrjson = JSON.parse(markRecords[idx]);
                              let zgInfo = this.selZgInfo["zg"+(idx+1)];
                              console.log('loadMarkRecord'+idx, zgInfo, mrjson);
                              
                              console.log("getBoundingClientRect", canLeft, canTop, canWidth, canHeight);
                              if(canTop < 0) canTop = 120;
                              
                              if("points" in mrjson && mrjson.points.length > 0){
                                  
                                  for (let j=0; j<mrjson.points.length; j++){
                                      let m = mrjson.points[j];
                                      
                                      // 计算显示位置
                                      let showY = canHeight * suoXiao(m.scaleY) + gu;
                                      let showX = canLeft + canWidth * suoXiao(m.scaleX);
                                      console.log("showX==>", showX);
                                      console.log("showY==>", showY);
                                      
                                      let o = Object.assign({}, m, {showX: showX, showY: showY});
                                      
                                      if(m.type == 4 && "wenziText" in m){
                                          let pw = m.wenziText.length * 20;
                                          o.w = 40 + pw;
                                          console.log("wenziText", m.wenziText, o);
                                      }
                                      // 以 topicIndex 去重，保留有 pointList 的
                                      let existing = uniqueMap.get(o.topicIndex);
                                      if(!existing){
                                          uniqueMap.set(o.topicIndex, o);
                                      }else{
                                          // 保留有 pointList 的
                                          if(o.pointList && o.pointList.length > 0 && (!existing.pointList || existing.pointList.length === 0)){
                                              uniqueMap.set(o.topicIndex, o);
                                          }
                                      }
                                  }
                              }
                          }
                      }
                      
                      
                      for (let o of uniqueMap.values()){
                          this.drawList.push(o);
                      }

                      // 防止重复导致的分数不对 以去重后的drawList 为准 重新更新下markrecord的题目对应分数
                      // 再根据 drawList 中的 pointList 更新 markRecords 中的分数
                      if(markRecords && markRecords.length > 0){
                          for (let idx=0; idx<markRecords.length; idx++){
                              if(markRecords[idx] != null){
                                  let mrjson = JSON.parse(markRecords[idx]);
                                  if(mrjson.scoreInfo && mrjson.scoreInfo.topicData){
                                      let topicData = mrjson.scoreInfo.topicData;
                                      for (let i=0; i<this.drawList.length; i++){
                                          let point = this.drawList[i];
                                          if(point.pointList && point.pointList.length > 0){
                                              let totalScore = 0;
                                              for (let j=0; j<point.pointList.length; j++){
                                                  totalScore += point.pointList[j].score || 0;
                                              }
                                              let tfind = XEUtils.find(topicData, item => item.topicIndex == point.topicIndex);
                                              if(tfind){
                                                  tfind.score = totalScore;
                                              }
                                          }
                                      }
                                      // // debugger
                                      let totalScore = 0;
                                      for (let i=0; i<topicData.length; i++){
                                          totalScore += topicData[i].score || 0;
                                      }
                                      // // debugger
                                      mrjson.scoreInfo.score = totalScore;
                                      // // debugger
                                      // 把更新后的数据存回去
                                      markRecords[idx] = JSON.stringify(mrjson);
                                      this.$set(markRecords, idx, JSON.stringify(mrjson));
                                  }
                              }
                          }
                      }
                    
                  }
                  
              }else{
                  if(this.isQuickScore){
                      if(this.fillBlankList.length > 0){
                          //  清空标记
                          this.drawList = [];
                          for (let i=0; i<this.fillBlankList.length; i++){
                              let item = JSON.parse(JSON.stringify(this.fillBlankList[i]));
                              if(item.type == 100) item.pointList = [];
                              this.drawList.push(item);
                          }
                      }
                  }
              }
              if(callback) callback();
            },
            // 画布点击事件（点击）
            canvasClick(e){
              let gu = 121;
                if(this.drawMode > 0){
                  // 获取点击位置的坐标信息
                  let rect = this.myCanvas.getBoundingClientRect();
                    let x = e.clientX, y = e.clientY, cha = 0;
                    x = x -10
                    y = y -15
                    if(rect.top>=0 && rect.top <=gu){
                      cha = parseInt(gu-rect.top);
                    }
                    if(rect.top <0){
                      cha = 0 - parseInt(rect.top-gu)
                    }
                    y = y + cha;
                    let beginHeight =rect.top, endHeight = (rect.top>0)?(rect.top+rect.height):(rect.height-rect.top);
                    // if(rect.top > 0) {y = y + scrollTop; showY = showY + scrollTop; }
                    let scaleX = (x-rect.left) / rect.width;
                    let scaleY = (y-gu) / rect.height;
                    console.log("canvasClick", e.clientX,  e.clientY, x, y, rect, cha, scaleX.toFixed(2), scaleY.toFixed(2));

                    if(y > beginHeight && y < endHeight){
      
                        // showX,showY 做偏移处理，使点击位置居中
                        // let new_x = x -10
                        // let new_y = y -15
                        let o = { 
                          index: this.drawList.length, 
                          w: 40, 
                          h: 40, 
                          x: x, 
                          y: y, 
                          scaleX: scaleX , 
                          scaleY: scaleY ,
                          showX: x, 
                          showY: y, 
                          type: this.drawMode, 
                          isR: false, 
                          isD: true, 
                          move: true,
                           // 默认批阅是红色
                          color: 'indianred'
                        };

                      // // debugger
                      // 修改状态时 修改批阅 颜色
                      if(this.isEdit){
                        if(this.userInfo.id == this.selZgInfo.teacherId){
                          o["power"] = 1;
                          o["color"] = 'darkred';
                        }else{
                          o["power"] = 2;
                          o["color"] = 'indianred';
                        }

                      }
                        if(this.drawMode == 3 || this.drawMode == 4 || this.drawMode == 14) {
                            o.w = 80; o.isR = true;
                        }
                        if(this.drawMode == 12) {
                            o.h = 5; o.w = 100; o.isR = true;
                        }

                        //踩点打分
                        if(this.drawMode == 99) { 
                          // // debugger
                            if((!XEUtils.isNumber(this.caiDian.myScore)) || this.isQuickScore) return;
                            o["score"] = this.caiDian.myScore;
                            o["topicIndex"] = this.caiDian.topicIndex;
                            o["scoreStep"] = this.caiDian.step;
                            let isSuccess = this.$refs.rightPanel.caidianScore(this.caiDian.topicIndex, this.caiDian.myScore);
                            if(!isSuccess){
                                this.$message({message: '点击分数不能超过满分或小于0分！', type: 'error', duration: 2000});
                                return;
                            }
                        }
                        this.drawList.push(o);
                        console.log("-------o-------");
                        console.log(o);
                        console.log("--------------");
                        if(this.drawMode == 4) {
                            this.drawMode = -1;
                            this.$refs.operPanel.unSelAll();
                        }
                        console.log("canvasClick", o);
                    }else{
    
                      console.log("not in", e.clientX,  e.clientY, x, y, rect, scaleX, scaleY);
                    }
                }
              this.selPointIndex = -1
            },
            // 选中题目，获得题目信息(打分侧边栏选中题序)
            selectPoint(id, arrIdx){
                this.selPoint = this.drawList[arrIdx];
                console.log("selPoint", this.selPoint);
                this.selPointIndex = arrIdx;
                console.log('selectPoint', arrIdx, this.selPoint.showX, this.selPoint.showY);
                // 填空题踩点打分时，选中侧边栏的题序
                if(this.isQuickScore) this.$refs.rightPanel.scoreFocusByIndex(arrIdx)
            },
          
            changePoint(id, arrIdx, newRect, wenziText){
              // // debugger
                let selPoint = this.drawList[arrIdx];
                this.selPointIndex = arrIdx;
                let gu = 121;
                if(newRect != null){
                  let rect = this.myCanvas.getBoundingClientRect();
                  let cha = 0;
                  let x = newRect.left - rect.left;
                  let y = newRect.top;
                  let scaleX = x /  rect.width;
                  let scaleY = (y-gu) / rect.height;
                  if(scaleX < 0 || scaleX > 1) return;
                  if(scaleY < 0 || scaleY > 1) return;
                  selPoint.w = newRect.width;
                  selPoint.h = newRect.height;
                  selPoint.y = y;
                  selPoint.x = x;
                  selPoint.showX = newRect.left;
                  selPoint.showY = newRect.top;
                  selPoint.scaleX = scaleX;
                  selPoint.scaleY = scaleY;
                  // 涉及到的canvas
                  // selPoint.myCanvas1Info = newRect.myCanvas1Info;
                  selPoint.rect = rect;
                  selPoint.pageHeights = this.pageHeights;

                  // console.log("换算后的 ====》",arrIdx,selPoint);


                  selPoint["move"] = true

                  // // debugger
                  // 修改状态时 修改批阅标志颜色
                  if(this.isEdit){
                    if(this.userInfo.id == this.selZgInfo.teacherId){
                      selPoint["power"] = 1;
                      selPoint["color"] = 'darkred';
                      // this.$set(selPoint, "power", 1);
                      // this.$set(selPoint, "color", 'darkred');
                    }else{
                      selPoint["power"] = 2;
                      selPoint["color"] = 'indianred';
                      // this.$set(selPoint, "power", 2);
                      // this.$set(selPoint, "color", 'indianred');
                    }
                  }
                  // console.log("changePoint", scaleX, scaleY, rect.height);
                }
                if(wenziText != null){
                    selPoint["wenziText"] = wenziText;
                    console.log("wenziText", wenziText, wenziText.length);
                    let pw =  wenziText.length * 25;
                    if(pw > selPoint.w) selPoint.w = pw;
                }
            },
            changeScore(id, arrIdx, tiScore, tiStep){
                let selPoint = this.drawList[arrIdx];
                this.selPointIndex = arrIdx;
                selPoint["score"] = tiScore;
                this.$refs.rightPanel.caidianScore(selPoint.topicIndex, tiStep);
            },
            openSearchDialog(){
              this.$refs.searchDialog.showDialog(this.searchIxList);
            },
            operOK(seq){
                this.drawMode = seq;
            },
            closeViewer(){
                this.showViewer = false;
            },
            // 点击步长(获得踩点步长的信息，步长值，总分等)
            rpChangeMode(mode, o){
              // debugger
                this.drawMode = mode;
                this.caiDian = o;
                if("operPanel" in this.$refs && this.$refs.operPanel != null) this.$refs.operPanel.unSelAll();
            },
            rpSubmitScore(o){
              // // debugger
              let zgIds = this.selZgInfo.zgIds;
              // 判断是否从存疑列表进行审批
              let menuType = this.selMenu.key.includes('zgyc-')
              console.log("rpSubmitScore", this.selZgInfo, this.drawList);
              let zgList = [];
              let isCd = false, cdScore = 0, gu = 121; //踩点分数
              let rect = this.myCanvas.getBoundingClientRect();
              let myHeight = document.documentElement.clientHeight
              let saveY = 0;
              if(rect.top>=0 && rect.top <=gu) saveY = parseInt(gu-rect.top);
              if(rect.top <0) saveY = parseInt(rect.top-gu);
              let beginHeight = 0, endHeight = 0, zgCount = zgIds.length;
              let rectLeft = rect.left, rectTop = rect.top, rectWidth = rect.width, rectHeight = rect.height;
              let zgMarkList = [];
                for (let i=0; i<zgCount; i++){
                  let zgId = zgIds[i];
                  let zgImg = this.selZgInfo["zg"+(i+1)];
                  if(i > 0) beginHeight = endHeight;
                  endHeight = endHeight  + zgImg.height;
                  for (let j=0; j<this.drawList.length; j++){
                    let _d = this.drawList[j];
                    let d = JSON.parse(JSON.stringify(_d));
                    d["blockIndex"] = i
                    if(!("move" in d)){
                      zgMarkList.push(d);
                      console.log("move", d);
                      continue;
                    }
                    let x = d.scaleX * rectWidth;
                    let y = d.scaleY * rectHeight + d.h/2;
                    console.log("submit for", d.x, d.y, zgImg.width, zgImg.height, rectLeft, rectTop, rectWidth, rectHeight);
                    if(d.type == 3 || d.type == 4){
                        if(x < zgImg.width && y >= beginHeight && y <= endHeight){
                            d["scaleX1"] = x / zgImg.width;
                            d["scaleY1"] = (d.scaleY * rectHeight-beginHeight) / zgImg.height; //d["scaleY1"] = (d.y-beginHeight) / zgImg.height;
                          if(d["scaleY1"] > 1) d["scaleY1"] = 1
                            if(d.type == 99) {cdScore = cdScore + d.score; isCd = true; }
                            zgMarkList.push(d);
                        }else{
                          if(zgCount == 1){
                            if(x >= zgImg.width) d["scaleX1"] = 1;
                            if(y >= endHeight) d["scaleY1"] = 1;
                            if(y < beginHeight) d["scaleY1"] = 0;
                            if(d.type == 99) {cdScore = cdScore + d.score; isCd = true; }
                            zgMarkList.push(d);
                          }
                        }
                    }else{
                        if(x < zgImg.width && y >= beginHeight && y <= endHeight){
                          console.log("contain_for", x, y, zgImg.width, zgImg.height, beginHeight, endHeight, rectLeft, rectTop, rectWidth, rectHeight);
                          d["scaleX1"] = x / zgImg.width;
                          d["scaleY1"] = (d.scaleY * rectHeight-beginHeight) / zgImg.height;
                          if(d["scaleY1"] > 1) d["scaleY1"] = 1
                          if(d.type == 99) {cdScore = cdScore + d.score; isCd = true; }
                          zgMarkList.push(d);
                        }else{
                          if(zgCount == 1){
                            if(x >= zgImg.width) d["scaleX1"] = 1;
                            if(y >= endHeight) d["scaleY1"] = 1;
                            if(y < beginHeight) d["scaleY1"] = 0;
                            if(d.type == 99) {cdScore = cdScore + d.score; isCd = true; }
                            zgMarkList.push(d);
                          }
                        }
                    }
                  }
                  let zgMark = { points: zgMarkList, scoreInfo: o};
                  if(this.topicType=='FillBlank') {
                    this.fillBlankList = []
                    zgMark["isQuickScore"] = this.isQuickScore
                    if(this.isQuickScore){
                      for (let k=0; k<this.drawList.length; k++) {
                        if (this.drawList[k].type == 100) {
                          let fobj = JSON.parse(JSON.stringify(this.drawList[k]))
                          fobj.score = 0
                          if("color" in fobj){ delete fobj.color }
                          this.fillBlankList.push(fobj);
                        }
                      }
                    }
                  }
                  // // debugger
                  // 修改状态时 修改批阅标志颜色
                  if(this.isEdit) {zgMark["power"] = 1; zgMark["color"] = 'darkred';}

                  console.log("zgMarkList", beginHeight, endHeight, zgMark, zgMarkList);
                  let zg = {id: zgId, status: 'YY', score: o.score, markRecord: JSON.stringify(zgMark), teacherId: this.userInfo.id, drawImg: null };
                  zgList.push(zg);
                }

                console.log('zgList', zgList);
                if(isCd && cdScore>=0 && cdScore != o.score){
                    this.$alert('踩点打分总分:'+ cdScore+'，与计算分:'+ o.score + ' 不一致！', '提示');
                    return ;
                }
                debugger
                // 校验markRecord是否会为空值
                let checkZgList = this.rpSubmitScoreCheck(zgList)
                //  仅多题填空题进行判断
                let isDuplicateIndexTopic = false
                if(this.drawMode == 100) isDuplicateIndexTopic = this.checkDuplicateIndexTopic(zgList)
                // let isDuplicateIndexTopic = this.checkDuplicateIndexTopic(zgList)

                // 如果有重复的records 不允许提交成绩并报错
                if(isDuplicateIndexTopic){
                  // // debugger
                  // this.simpleD(zgList)
                  this.$message.error("提交成绩失败，请刷新窗口重新批阅分数！")
                  return
                }
                let that = this;
                let param = { controllerName: 'examTask', methodName: '/updateZg', param: { examId: XEUtils.toNumber(this.examId), zgList: checkZgList, menuType: menuType,licenceId:this.userInfo.licenceId}};
                
                simpleApi.post(param).then(({ result: { code, data}, sysCode}) =>  {
                    if (code == 0) {
                        this.$message({message: '阅卷打分成功！', type: 'success', duration: 2000});
                        this.examImageList = [];
                        this.loadExam(function () {
                            that.loadExamTopic(function () {
                                that.loadMenu(function () {
                                    that.drawList = [];
                                    that.loadZgExam();
                                });
                            });
                        });

                        // // 获取 canvas 元素和上下文
                        // const canvas = document.getElementById('myCanvas1');
                        // const ctx = canvas.getContext('2d');

                        // // 清空整个画布
                        // ctx.clearRect(0, 0, canvas.width, canvas.height);


                    }else{
                        this.$alert('阅卷失败！' + data, '提示');
                        this.reload();
                    }
                    this.loading = false;
                });
            },
            openViewer(){
                this.showViewer = true;
            },
            rpSubmitScoreRecheck(o){
              debugger
              let zgIds = this.selZgInfo.zgIds;
              // 判断是否从存疑列表进行审批
              let menuType = this.selMenu.key.includes('zgyc-')
              console.log("rpSubmitScore", this.selZgInfo, this.drawList);
              let zgList = [];
              let isCd = false, cdScore = 0, gu = 121; //踩点分数
              let rect = this.myCanvas.getBoundingClientRect();
              let myHeight = document.documentElement.clientHeight
              let saveY = 0;
              if(rect.top>=0 && rect.top <=gu) saveY = parseInt(gu-rect.top);
              if(rect.top <0) saveY = parseInt(rect.top-gu);
              let beginHeight = 0, endHeight = 0, zgCount = zgIds.length;
              let rectLeft = rect.left, rectTop = rect.top, rectWidth = rect.width, rectHeight = rect.height;
              let zgMarkList = [];
              // debugger
              for (let i=0; i<zgCount; i++){
                
                let zgId = zgIds[i];
                let zgImg = this.selZgInfo["zg"+(i+1)];
                if(i > 0) beginHeight = endHeight;
                endHeight = endHeight  + zgImg.height;
                for (let j=0; j<this.drawList.length; j++){
                  let _d = this.drawList[j];
                  let d = JSON.parse(JSON.stringify(_d));
                  d["blockIndex"] = i
                  if(!("move" in d)){
                    zgMarkList.push(d);
                    console.log("move", d);
                    continue;
                  }
                  let x = d.scaleX * rectWidth;
                  let y = d.scaleY * rectHeight + d.h/2;
                  console.log("submit for", d.x, d.y, zgImg.width, zgImg.height, rectLeft, rectTop, rectWidth, rectHeight);
                  if(d.type == 3 || d.type == 4){
                      if(x < zgImg.width && y >= beginHeight && y <= endHeight){
                          d["scaleX1"] = x / zgImg.width;
                          d["scaleY1"] = (d.scaleY * rectHeight-beginHeight) / zgImg.height; //d["scaleY1"] = (d.y-beginHeight) / zgImg.height;
                        if(d["scaleY1"] > 1) d["scaleY1"] = 1
                          if(d.type == 99) {cdScore = cdScore + d.score; isCd = true; }
                          zgMarkList.push(d);
                      }else{
                        if(zgCount == 1){
                          if(x >= zgImg.width) d["scaleX1"] = 1;
                          if(y >= endHeight) d["scaleY1"] = 1;
                          if(y < beginHeight) d["scaleY1"] = 0;
                          if(d.type == 99) {cdScore = cdScore + d.score; isCd = true; }
                          zgMarkList.push(d);
                        }
                      }
                  }else{
                      if(x < zgImg.width && y >= beginHeight && y <= endHeight){
                        console.log("contain_for", x, y, zgImg.width, zgImg.height, beginHeight, endHeight, rectLeft, rectTop, rectWidth, rectHeight);
                        d["scaleX1"] = x / zgImg.width;
                        d["scaleY1"] = (d.scaleY * rectHeight-beginHeight) / zgImg.height;
                        if(d["scaleY1"] > 1) d["scaleY1"] = 1
                        if(d.type == 99) {cdScore = cdScore + d.score; isCd = true; }
                        zgMarkList.push(d);
                      }else{
                        if(zgCount == 1){
                          if(x >= zgImg.width) d["scaleX1"] = 1;
                          if(y >= endHeight) d["scaleY1"] = 1;
                          if(y < beginHeight) d["scaleY1"] = 0;
                          if(d.type == 99) {cdScore = cdScore + d.score; isCd = true; }
                          zgMarkList.push(d);
                        }
                      }
                  }
                }
                let zgMark = { points: zgMarkList, scoreInfo: o};
                if(this.topicType=='FillBlank') {
                  this.fillBlankList = []
                  zgMark["isQuickScore"] = this.isQuickScore
                  if(this.isQuickScore){
                    for (let k=0; k<this.drawList.length; k++) {
                      if (this.drawList[k].type == 100) {
                        let fobj = JSON.parse(JSON.stringify(this.drawList[k]))
                        fobj.score = 0
                        if("color" in fobj){ delete fobj.color }
                        this.fillBlankList.push(fobj);
                      }
                    }
                  }
                }
                // // debugger
                if(this.isEdit) {zgMark["power"] = 1; zgMark["color"] = 'darkred';}
                console.log("zgMarkList", beginHeight, endHeight, zgMark, zgMarkList);
                let zg = {id: zgId, status: 'YY', score: o.score, markRecord: JSON.stringify(zgMark), teacherId: this.userInfo.id, drawImg: null };
                zgList.push(zg);
              }

              console.log('zgList', zgList);
              if(isCd && cdScore>=0 && cdScore != o.score){
                  this.$alert('踩点打分总分:'+ cdScore+'，与计算分:'+ o.score + ' 不一致！', '提示');
                  return ;
              }
              let that = this;
              let param = { controllerName: 'examTask', methodName: '/updateZg', param: { examId: XEUtils.toNumber(this.examId), zgList: zgList, menuType: menuType,licenceId:this.userInfo.licenceId}};
              simpleApi.post(param).then(({ result: { code, data}, sysCode}) =>  {
                  if (code == 0) {
                      this.$message({message: '复核打分成功！', type: 'success', duration: 2000});
      
                      this.examImageList = [];

                      // this.selZgInfo = null
                      // this.$ref.rightPanel.zgInfo = {}

                      // 获取 canvas 元素和上下文
                      // const canvas = document.getElementById('myCanvas1');
                      // const ctx = canvas.getContext('2d');

                      // // 清空整个画布
                      // ctx.clearRect(0, 0, canvas.width, canvas.height);
                      this.isNextByYC = true
                      this.loadExam(function () {
                          that.loadExamTopic(function () {
                              that.loadMenu(function () {
                                  // 启动存疑自动跳到下一位
                                  // this.isNextByYC = true
                                  that.drawList = [];
                                  that.loadZgExam("zgyc");
                              });
                          });
                      });

                      // this.selZgInfo = null
                      //  获取 canvas 元素和上下文
                      // const canvas = document.getElementById('myCanvas1');
                      // const ctx = canvas.getContext('2d');

                      // 清空整个画布
                      // ctx.clearRect(0, 0, canvas.width, canvas.height);
                      // this.drawList = [];
                      // this.loadMenu()
                      // this.loadExam()

                  }else{
                      this.$alert('阅卷失败！' + data, '提示');
                      this.reload();
                  }
                  this.loading = false;
              });
            },
            scaleChange(value){
              console.log("this.ctx.width -->" ,this.ctx.width);
              console.log("this.ctx.height -->" ,this.ctx.height);
              console.log("-------------------------------------------");

              this.scale = value
              this.loadCanvas()
              // let point = JSON.parse(JSON.stringify(this.drawList[0]))
              // point.showX = point.x * value
              // point.showY  = point.y * value
              // this.drawList.push(point)
              
              this.drawList.forEach((item,index) => {
                console.log("item.x==>" ,item.x);
                console.log("item.y==>" ,item.y);
                let sc_x = item.x / value
                let sc_y = item.y / value

                item.showX = sc_x
                item.showY = sc_y
                console.log("show.x==>" ,sc_x);
                console.log("show.y==>" ,sc_y);

              })



            },
            // 提交前校验
            rpSubmitScoreCheck(zgList){
              // debugger
              let drawMode = this.drawMode
              // 判断是否是空值
              if (!Array.isArray(zgList) || zgList.length === 0) return zgList

              // 取出zgList里边的markrecord 判断是否存在空值 ,获取第一个非空的 markrecord 作为基准
              let firstItem = zgList.find(item => item.markRecord != null && item.markRecord !== '');
              // 所有 markRecord 都是 null/undefined 就正常更新
              if (!firstItem) return zgList; 
              zgList.forEach(element => {
                if(element.markRecord == null || element.markRecord == undefined || element.markRecord == ''){
                  // 为空值的情况下
                  element.markRecord = firstItem.markRecord
                }else{
                  // 直接打分的批阅会走这边
                  // debugger 
                  // 仅限100情况下 在不为空的情况下 如果存在'points' 就过滤下没有topicIndex的- 防止未点击工具栏就点击图片出现的白框
                  
                  // if( drawMode == 100){
                  //   let markR = JSON.parse(element.markRecord)
                  //   if('points' in markR){
                  //     let points = markR.points.filter(item => 'topicIndex' in item)
                  //     markR.points = points
                  //     element.markRecord =  JSON.stringify(markR)
                  //   }
                  // }
                }
              });
              return zgList
            },
            // 提交前校验 markRecords 判断是否存在重复项 导致重复的题块scorePoint保存进后端
            rpSubmitByMarkRecord(){
            },
            checkDuplicateIndexTopicByMarkRecord(zgInfo) {
              // // debugger
              let points = zgInfo.markRecords
              // let points = JSON.parse(markRecord)
              // // debugger
              /**
               * 检查 points 中是否有完全相同的 index + topicIndex 重复
               */
              if (!points || !Array.isArray(points)) {
                  // return { hasDuplicate: false, duplicates: [] }
                  return false
              }
              
              // 按 (index, topicIndex) 组合分组
              let groups = new Map()
              
              points.forEach((item, idx) => {
                // // debugger
                  // if(!'markRecord' in item) return
                  let point = JSON.parse(item)

                  // // debugger
                  let pointIndex = point.index
                  let topicIndex = point.topicIndex
                  
                  if (pointIndex === undefined || topicIndex === undefined) return
                  
                  let key = `${pointIndex}_${topicIndex}`
                  
                  if (!groups.has(key)) {
                      groups.set(key, [])
                  }
                  groups.get(key).push({
                      arrayIndex: idx,
                      pointIndex: pointIndex,
                      topicIndex: topicIndex,
                      score: point.score,
                      hasPointList: point.pointList && point.pointList.length > 0
                  })
              })
              
              // 找出重复的
              let duplicates = []
              for (let [key, items] of groups.entries()) {
                  if (items.length > 1) {
                      let [pointIndex, topicIndex] = key.split('_')
                      duplicates.push({
                          key: key,
                          pointIndex: parseInt(pointIndex),
                          topicIndex: parseInt(topicIndex),
                          count: items.length,
                          items: items
                      })
                  }
              }
              let status = false
              if( duplicates.length > 0) status = true
              return  status
              // return {
              //     hasDuplicate: duplicates.length > 0,
              //     duplicates: duplicates
              // }
            },
            checkDuplicateIndexTopic(zgList) {
              // debugger
              /**
               * 检查 zgList 中每个对象的 markRecord 里的 points 是否有完全相同的 index + topicIndex 重复
               */
              // 先判断是数组 还是 对象(仅{})
              let ob = zgList && Object.prototype.toString.call(zgList) === '[object Object]'
              let ar = Array.isArray(zgList)
              if(ob){
                // 对象类型 判断是否存在''points' in zgList
                if('points' in zgList){
                  let points = zgList['points']
                  // 按 (index, topicIndex) 组合分组
                  let groups = new Map()
                  for (let j = 0; j < points.length; j++) {
                            let point = points[j]
                            let pointIndex = point.index
                            let topicIndex = point.topicIndex
                            
                            if (pointIndex === undefined || topicIndex === undefined) continue
                            
                            let key = `${pointIndex}_${topicIndex}`
                            
                            if (!groups.has(key)) {
                                groups.set(key, [])
                            }
                            groups.get(key).push({
                                arrayIndex: j,
                                pointIndex: pointIndex,
                                topicIndex: topicIndex,
                                score: point.score,
                                hasPointList: point.pointList && point.pointList.length > 0
                            })
                        }
                        
                        // 检查是否有重复
                        for (let [key, items] of groups.entries()) {
                            if (items.length > 1) {
                                // 发现重复，打印详细信息
                                // console.error(`发现重复: zg.id=${zg.id}, ${key} 重复了 ${items.length} 次`)
                                return true  // 有重复直接返回 true
                            }
                        }

                }else{
                  return false
                }

              }
              // debugger
              if(ar){
                // debugger
                // if (!zgList || !Array.isArray(zgList) || zgList.length === 0) {
                if (!zgList  || zgList.length === 0) {
                    return false
                }
                
                for (let i = 0; i < zgList.length; i++) {
                    let zg = zgList[i]
                    if (!zg.markRecord) continue
                    
                    try {
                        let markRecordObj = JSON.parse(zg.markRecord)
                        let points = markRecordObj.points || []
                        
                        if (points.length === 0) continue
                        
                        // 按 (index, topicIndex) 组合分组
                        let groups = new Map()
                        
                        for (let j = 0; j < points.length; j++) {
                            let point = points[j]
                            let pointIndex = point.index
                            let topicIndex = point.topicIndex
                            
                            if (pointIndex === undefined || topicIndex === undefined) continue
                            
                            let key = `${pointIndex}_${topicIndex}`
                            
                            if (!groups.has(key)) {
                                groups.set(key, [])
                            }
                            groups.get(key).push({
                                arrayIndex: j,
                                pointIndex: pointIndex,
                                topicIndex: topicIndex,
                                score: point.score,
                                hasPointList: point.pointList && point.pointList.length > 0
                            })
                        }
                        
                        // 检查是否有重复
                        for (let [key, items] of groups.entries()) {
                            if (items.length > 1) {
                                // 发现重复，打印详细信息
                                console.error(`发现重复: zg.id=${zg.id}, ${key} 重复了 ${items.length} 次`)
                                return true  // 有重复直接返回 true
                            }
                        }
                        
                    } catch(e) {
                        console.error('解析 markRecord 失败:', e, zg.id)
                        continue
                    }
                }
                
                return false  // 全部都没有重复
                }
            },
            checkDuplicateIndexTopicByInfo(info) {
              if (!info.markRecords) return false
              

                  
                  try {
                      let markRecordObj = JSON.parse(info.markRecords)
                      let points = markRecordObj.points || []
                      
                      if (points.length === 0) return false
                      
                      // 按 (index, topicIndex) 组合分组
                      let groups = new Map()
                      
                      for (let j = 0; j < points.length; j++) {
                          let point = points[j]
                          let pointIndex = point.index
                          let topicIndex = point.topicIndex
                          
                          if (pointIndex === undefined || topicIndex === undefined) continue
                          
                          let key = `${pointIndex}_${topicIndex}`
                          
                          if (!groups.has(key)) {
                              groups.set(key, [])
                          }
                          groups.get(key).push({
                              arrayIndex: j,
                              pointIndex: pointIndex,
                              topicIndex: topicIndex,
                              score: point.score,
                              hasPointList: point.pointList && point.pointList.length > 0
                          })
                      }
                      
                      // 检查是否有重复
                      for (let [key, items] of groups.entries()) {
                          if (items.length > 1) {
                              // 发现重复，打印详细信息
                              // // debugger
                              // console.error(`发现重复: zg.id=${zg.id}, ${key} 重复了 ${items.length} 次`)
                              return true  // 有重复直接返回 true
                          }
                      }
                      
                  } catch(e) {
                      // console.error('解析 markRecord 失败:', e, zg.id)
                      return false
                  }

              
              return false  // 全部都没有重复
            },
            // 仅填空题踩点打分时使用 (type == 100)
            changeCaiDianScore(id, arrIdx,totalScore,pointList){
              // 填空题的踩点作答分数不从侧边打分步长处取，取得步长的值
               let selPoint = this.drawList[arrIdx];
               // 新增/更新坐标
               this.drawList[arrIdx].pointList = pointList
               this.selPointIndex = arrIdx;
               let myScore = parseFloat(totalScore)
               selPoint["score"] = myScore;
               let calcScore = myScore
               if(myScore<0) calcScore = this.caiDian.rightScore + myScore;
               this.$refs.rightPanel.caidianScore(selPoint.topicIndex, calcScore, true);
              },
              getFillBlankByYY(topicData,canLeft,canTop,canWidth,canHeight){
                this.drawList = []
                let params = { examId: XEUtils.toNumber(this.examId), examSeq:this.selZgInfo.examSeq,limit:1,status:'YY'}
                let param = { controllerName: 'exam/zg', methodName: '/getFillBlankByYY', param: params};
                simpleApi.post(param).then(({ result: { code, data}, sysCode}) =>  {
                  if(data != null){
                    // debugger
                    let markRecord = JSON.parse(data.markRecord)
                    let point = markRecord.points
                    // 判断是否存在重复record 重复则进行去重
                    let isDuplicateIndexTopic = this.checkDuplicateIndexTopic(markRecord)
                    // debugger
                    if(!isDuplicateIndexTopic){
                      //  直接注入
                      for (let i=0; i<point.length; i++){
                        // 仅保留有topicIndex字段的point(直接注入会把勾叉等打分标记也加入进去)
                        // debugger
                        if("topicIndex" in  point[i]){
                          let o = point[i]
                          o.pointList = []
                          this.drawList.push(o)
                        }
           
                      }
                    }else{
                      // 防止保留markRecord 时候出现重复 按topicIndex去重，保留有pointList数据的
                      let uniqueMap = new Map()
                      for (let i=0; i< point.length; i++){
                          let o = point[i]
                          let existing = uniqueMap.get(o.topicIndex)
                          if(!existing){
                              // 第一次出现，直接放入
                              o.pointList = []
                              uniqueMap.set(o.topicIndex, o)
                          }
                          // else{
                          //     // 已存在，优先保留有pointList数据的
                          //     if(o.pointList && o.pointList.length > 0 && (!existing.pointList || existing.pointList.length === 0)){
                          //         uniqueMap.set(o.topicIndex, o)
                          //     }
                          // }
                      }
                      // 将去重后的数据添加到drawList
                      for (let o of uniqueMap.values()){
                          this.drawList.push(o)
                      }
                    }


                   
                  }else{
                    // 默认复原位置
                    for (let i=0; i<topicData.length; i++) {
                      let t = topicData[i]
                      let x = canLeft + (i%3)*120 + 10, y = canTop + parseInt(i/3) * 40+5;
                      // let ixIdx = XEUtils.findIndexOf(this.drawList, item => (item.type == 100 && item.topicIndex==t.topicIndex));
                      let o = { 
                        index: this.drawList.length, 
                        w: 80, h: 40, x: x, y: y, scaleX: x, scaleY: y, 
                        topicIndex: t.topicIndex,
                        showX: x, showY: y, 
                        type: 100, 
                        score: 0, scoreStep: 0.5, rightScore: t.rightScore, 
                        isR: true, isD: true, move: true};
                      // if(ixIdx > -1){
                      //   o.score = this.drawList[ixIdx].score;
                      //   this.drawList.splice(ixIdx, 1)
                      // }
                      setTimeout(()=>{
                        this.drawList.push(o)
                      }, 500);
                    }
                  }
                })
              },
              // 更新工具栏的位置信息
              updateOptionInfo(value){
                this.operInfo = {
                  x: value.x,
                  y: value.y
                }
              },
              // 行政班 点击显示子菜单
              handleNumberClick(value,item){
                let studentCheckType = !value.studentCheckType
                value.studentCheckType = studentCheckType
                this.studentCheckList[value.key] = studentCheckType

              },
              // 获取指定题号批阅学生列表
              getHardStudentByExam(search,idxCount){
                let list = []
                let param = { controllerName: 'exam/zg', methodName: '/getHardStudentByExam',  param: search};
                return simpleApi.list(param).then(({result: {code, data}}) =>  {
                  // 处理数据格式
                  data.forEach((ele,index) => {
                    let item = {
                      key: 'zg-' + ele.id,
                      name: ele.name,
                      first:true,
                      isModify: false,
                      data: {
                        examId: ele.exam_id,
                        examSeq: ele.exam_seq,
                        idxCount: idxCount,
                        inStatus: null,
                        isEdit: true,
                        status: ele.status,
                        studentId: ele.student_id
                      }
                      
                    }
                    list.push(item)
                  })
                  return list
                }).catch((error) => {
                    console.log("error")
                    return list
                });
              },
              // 学生信息分页
              handleCurrentChange(val){
                this.searchForm.pageNo = val;
                this.loadDownloadList()
              },
              // 每页显示多少条
              handleSizeChange(val){
                  this.searchForm.pageSize = val;
                  this.loadDownloadList()
              },
              // 跳转到检测页面
              jumpCheck(){
                let url = '#/scoringCheck?examId=' + this.examId
                window.open(url, '_blank')
              },
              // 阅卷进度
              openProgress(){
                this.selProgress = Object.assign({examId: this.examId, time: (new Date()).getMilliseconds()}, this.examInfo);
                this.$refs.progressDialog.showDialog();
              },
              // 查询当前考试下对应题号的idxCount列表
              getIdxCountByExamSeq() {
                let search = { examId: this.examId };
                let param = { controllerName: 'examTask', methodName: '/selectTeacherZgSeq', param: search };
                return simpleApi.list(param).then(({ result: { code, data } }) => {
                  // // debugger
                  let idCountList = {};
                  (data || []).forEach(item => {
                    // // debugger
                    let examSeq = item.exam_seq;
                    let idCount = item.all_cou / item.cou;
                    // 如果整除不是整数 默认最大值
                    if (!Number.isInteger(idCount)) {
                      idCount = 4
                    }
                    idCountList[examSeq] = idCount;
                  });
                  this.idCountList = idCountList;
                  console.log("idCountList ==》", idCountList);
                });
              },
              // 简单去重
              simpleD(zgList){
                let ob = zgList && Object.prototype.toString.call(zgList) === '[object Object]'
                let ar = Array.isArray(zgList)
                if(ob){
                  // debugger
                  if('points' in zgList){
                    let point = zgList['points']
                    
                    // 防止保留markRecord 时候出现重复 按topicIndex去重，保留有pointList数据的
                    let uniqueMap = new Map()
                    for (let i=0; i< point.length; i++){
                        let o = point[i]
                        let existing = uniqueMap.get(o.topicIndex)
                        if(!existing){
                            // 第一次出现，直接放入
                            uniqueMap.set(o.topicIndex, o)
                        }else{
                            // 已存在，优先保留有pointList数据的
                            if(o.pointList && o.pointList.length > 0 && (!existing.pointList || existing.pointList.length === 0)){
                                uniqueMap.set(o.topicIndex, o)
                            }
                        }
                    }
                    // debugger
                    // 将去重后的数据添加到drawList
                    for (let o of uniqueMap.values()){
                        // this.drawList.push(o)
                    }
                  }

                }
              }


        },


    }
</script>

<style lang="scss" scoped type="text/scss" rel="stylesheet/scss">

    .scoring{
        .item {
            margin: 4px;
        }
        .el-header {
            // background-color: #02b6fd;
            color: white;
            line-height: 60px;
            .icon {
                line-height: 60px;
                height: 30px;
                width: 30px;
                font-size: 26px;
            }
            .head {
                font-size: 16px;
                text-align: left;
            }
        }
        .el-aside {
            color: #333;
        }

    }


    .nav-buttons {
      display: flex;
      gap: 20px;
    }

    .nav-item {
      display: flex;
      flex-direction: column;
      align-items: center;
      cursor: pointer;
      line-height: 1;  /* 关键：减少行高 */
    }

    .nav-item i {
      font-size: 22px;
      line-height: 1;  /* 关键：图标行高设为1 */
      height: auto;    /* 关键：去掉固定高度 */
      margin-bottom: 15px;
    }

    .nav-item span {
      font-size: 12px;
      line-height: 1;  /* 关键：文字行高设为1 */
      height: auto;    /* 关键：去掉固定高度 */
    }

    /* 可选：悬停效果 */
    .nav-item:hover i,
    .nav-item:hover span {
      color: #409eff;
    }

</style>


